// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  AcceptAccessTrainingCorrectionData,
  AcceptAccessTrainingCorrectionErrors,
  AcceptAccessTrainingCorrectionResponses,
  AcceptApproverMatchesData,
  AcceptApproverMatchesErrors,
  AcceptApproverMatchesResponses,
  AcknowledgeAccessRejectionData,
  AcknowledgeAccessRejectionErrors,
  AcknowledgeAccessRejectionResponses,
  ActOnEmailIntakeData,
  ActOnEmailIntakeErrors,
  ActOnEmailIntakeResponses,
  ActOnRoutingRuleData,
  ActOnRoutingRuleErrors,
  ActOnRoutingRuleResponses,
  AddAccessCaseCommentData,
  AddAccessCaseCommentErrors,
  AddAccessCaseCommentResponses,
  AddHrGroupMemberData,
  AddHrGroupMemberErrors,
  AddHrGroupMemberResponses,
  AddReportNoteData,
  AddReportNoteErrors,
  AddReportNoteResponses,
  AddRoutingDispatcherData,
  AddRoutingDispatcherErrors,
  AddRoutingDispatcherResponses,
  AddRoutingRuleData,
  AddRoutingRuleErrors,
  AddRoutingRuleResponses,
  AddTeamMemberData,
  AddTeamMemberErrors,
  AddTeamMemberResponses,
  AddTicketCommentData,
  AddTicketCommentErrors,
  AddTicketCommentResponses,
  AdminCreateMessageData,
  AdminCreateMessageErrors,
  AdminCreateMessageResponses,
  AdminDeleteMessageData,
  AdminDeleteMessageErrors,
  AdminDeleteMessageResponses,
  AdminGetAgentStatusData,
  AdminGetAgentStatusResponses,
  AdminGetFeedbackSummaryData,
  AdminGetFeedbackSummaryErrors,
  AdminGetFeedbackSummaryResponses,
  AdminGetUsageSummaryData,
  AdminGetUsageSummaryErrors,
  AdminGetUsageSummaryResponses,
  AdminListErrorFeedbackData,
  AdminListErrorFeedbackErrors,
  AdminListErrorFeedbackResponses,
  AdminListFeedbackData,
  AdminListFeedbackErrors,
  AdminListFeedbackResponses,
  AdminListLeadershipFeedbackData,
  AdminListLeadershipFeedbackErrors,
  AdminListLeadershipFeedbackResponses,
  AdminListMessagesData,
  AdminListMessagesResponses,
  AdminListRaisedTicketsData,
  AdminListRaisedTicketsErrors,
  AdminListRaisedTicketsResponses,
  AdminListRecentFixesData,
  AdminListRecentFixesResponses,
  AdminListSignInsData,
  AdminListSignInsErrors,
  AdminListSignInsResponses,
  AdminMessageHistoryData,
  AdminMessageHistoryErrors,
  AdminMessageHistoryResponses,
  AdminReopenFeedbackData,
  AdminReopenFeedbackErrors,
  AdminReopenFeedbackResponses,
  AdminResolveFeedbackData,
  AdminResolveFeedbackErrors,
  AdminResolveFeedbackResponses,
  AdminUpdateMessageData,
  AdminUpdateMessageErrors,
  AdminUpdateMessageResponses,
  AnswerTicketInfoRequestData,
  AnswerTicketInfoRequestErrors,
  AnswerTicketInfoRequestResponses,
  AskReportData,
  AskReportErrors,
  AskReportResponses,
  BulkChangeApproversData,
  BulkChangeApproversErrors,
  BulkChangeApproversResponses,
  CancelAssistantMessageData,
  CancelAssistantMessageErrors,
  CancelAssistantMessageResponses,
  CheckAccessDuplicateData,
  CheckAccessDuplicateErrors,
  CheckAccessDuplicateResponses,
  CloseTicketData,
  CloseTicketErrors,
  CloseTicketResponses,
  CommentKnowledgeArticleData,
  CommentKnowledgeArticleErrors,
  CommentKnowledgeArticleResponses,
  CommitKnowledgeImportData,
  CommitKnowledgeImportErrors,
  CommitKnowledgeImportResponses,
  CompleteAccessTrainingData,
  CompleteAccessTrainingErrors,
  CompleteAccessTrainingResponses,
  ConfirmAccessRosterEntryData,
  ConfirmAccessRosterEntryErrors,
  ConfirmAccessRosterEntryResponses,
  ConfirmStarterAccountData,
  ConfirmStarterAccountErrors,
  ConfirmStarterAccountResponses,
  ConfirmTicketResolutionData,
  ConfirmTicketResolutionErrors,
  ConfirmTicketResolutionResponses,
  CreateApproverRuleData,
  CreateApproverRuleErrors,
  CreateApproverRuleResponses,
  CreateApproverSystemData,
  CreateApproverSystemErrors,
  CreateApproverSystemResponses,
  CreateConversationData,
  CreateConversationErrors,
  CreateConversationResponses,
  CreateDemoCaseData,
  CreateDemoCaseResponses,
  CreateKnowledgeAreaData,
  CreateKnowledgeAreaErrors,
  CreateKnowledgeAreaResponses,
  CreateKnowledgeArticleData,
  CreateKnowledgeArticleErrors,
  CreateKnowledgeArticleResponses,
  CreateResourceOwnerData,
  CreateResourceOwnerErrors,
  CreateResourceOwnerResponses,
  CreateTicketData,
  CreateTicketErrors,
  CreateTicketResponses,
  DecideAccessApprovalData,
  DecideAccessApprovalErrors,
  DecideAccessApprovalResponses,
  DecideRoutingData,
  DecideRoutingErrors,
  DecideRoutingResponses,
  DeleteApproverRuleData,
  DeleteApproverRuleErrors,
  DeleteApproverRuleResponses,
  DeleteApproverSystemData,
  DeleteApproverSystemErrors,
  DeleteApproverSystemResponses,
  DeleteConversationData,
  DeleteConversationErrors,
  DeleteConversationResponses,
  DismissAccessTrainingCorrectionData,
  DismissAccessTrainingCorrectionErrors,
  DismissAccessTrainingCorrectionResponses,
  DismissAccessTrainingPromptData,
  DismissAccessTrainingPromptResponses,
  EndApproverCoveringData,
  EndApproverCoveringErrors,
  EndApproverCoveringResponses,
  ExportAccessCompletedData,
  ExportAccessCompletedErrors,
  ExportAccessCompletedResponses,
  ExportAccessTrainingData,
  ExportAccessTrainingResponses,
  ExportApproverProblemsData,
  ExportApproverProblemsResponses,
  ExportApproversData,
  ExportApproversResponses,
  ExportKnowledgeData,
  ExportKnowledgeErrors,
  ExportKnowledgeResponses,
  ExportReportInsightsData,
  ExportReportInsightsErrors,
  ExportReportInsightsResponses,
  FileAccessItemData,
  FileAccessItemErrors,
  FileAccessItemResponses,
  FindSimilarTicketsData,
  FindSimilarTicketsErrors,
  FindSimilarTicketsResponses,
  GetAccessCaseData,
  GetAccessCaseErrors,
  GetAccessCaseResponses,
  GetAccessCatalogData,
  GetAccessCatalogResponses,
  GetAccessItemPrefillData,
  GetAccessItemPrefillErrors,
  GetAccessItemPrefillResponses,
  GetAccessPrefillData,
  GetAccessPrefillErrors,
  GetAccessPrefillResponses,
  GetAccessQueuesData,
  GetAccessQueuesResponses,
  GetAccessReferenceAccessData,
  GetAccessReferenceAccessErrors,
  GetAccessReferenceAccessResponses,
  GetAccessReferenceProfileData,
  GetAccessReferenceProfileErrors,
  GetAccessReferenceProfileResponses,
  GetAccessReferenceRolesData,
  GetAccessReferenceRolesErrors,
  GetAccessReferenceRolesResponses,
  GetAccessResourceOwnerData,
  GetAccessResourceOwnerErrors,
  GetAccessResourceOwnerResponses,
  GetAccessTrainingProgressData,
  GetAccessTrainingProgressResponses,
  GetAccessTrainingPromptData,
  GetAccessTrainingPromptResponses,
  GetApproverProblemsData,
  GetApproverProblemsErrors,
  GetApproverProblemsResponses,
  GetApproversOverviewData,
  GetApproversOverviewResponses,
  GetAssignSuggestionData,
  GetAssignSuggestionErrors,
  GetAssignSuggestionResponses,
  GetAssistantMessageData,
  GetAssistantMessageErrors,
  GetAssistantMessageResponses,
  GetCapabilitiesData,
  GetCapabilitiesResponses,
  GetConversationData,
  GetConversationErrors,
  GetConversationResponses,
  GetEmailIntakeItemData,
  GetEmailIntakeItemErrors,
  GetEmailIntakeItemResponses,
  GetHealthData,
  GetHealthResponses,
  GetIncidentFollowupsData,
  GetIncidentFollowupsErrors,
  GetIncidentFollowupsResponses,
  GetItAdminPersonAccessData,
  GetItAdminPersonAccessErrors,
  GetItAdminPersonAccessResponses,
  GetItAdminPersonData,
  GetItAdminPersonErrors,
  GetItAdminPersonResponses,
  GetKnowledgeArticleData,
  GetKnowledgeArticleErrors,
  GetKnowledgeArticleResponses,
  GetKnowledgeImportData,
  GetKnowledgeImportErrors,
  GetKnowledgeImportResponses,
  GetKnowledgeOverviewData,
  GetKnowledgeOverviewResponses,
  GetLatestReportData,
  GetLatestReportErrors,
  GetLatestReportResponses,
  GetMeData,
  GetMeResponses,
  GetMessageData,
  GetMessageErrors,
  GetMessageResponses,
  GetMigrateRequestFormData,
  GetMigrateRequestFormErrors,
  GetMigrateRequestFormResponses,
  GetMigrateStatusData,
  GetMigrateStatusResponses,
  GetMyAccessRosterData,
  GetMyAccessRosterResponses,
  GetMyTrainingRolesData,
  GetMyTrainingRolesResponses,
  GetReportInsightsData,
  GetReportInsightsErrors,
  GetReportInsightsResponses,
  GetReportRefreshStatusData,
  GetReportRefreshStatusErrors,
  GetReportRefreshStatusResponses,
  GetReportSnapshotData,
  GetReportSnapshotErrors,
  GetReportSnapshotResponses,
  GetRequestOfferingData,
  GetRequestOfferingErrors,
  GetRequestOfferingResponses,
  GetRoutingRegisterData,
  GetRoutingRegisterResponses,
  GetStarterCaseData,
  GetStarterCaseErrors,
  GetStarterCaseResponses,
  GetStarterPrefillData,
  GetStarterPrefillErrors,
  GetStarterPrefillResponses,
  GetTeamData,
  GetTeamErrors,
  GetTeamResponses,
  GetTeamsBotStatusData,
  GetTeamsBotStatusResponses,
  GetTicketAttachmentDownloadData,
  GetTicketAttachmentDownloadErrors,
  GetTicketAttachmentDownloadResponses,
  GetTicketByNumberData,
  GetTicketByNumberErrors,
  GetTicketByNumberResponses,
  GetTicketData,
  GetTicketErrors,
  GetTicketMetadataData,
  GetTicketMetadataResponses,
  GetTicketResponses,
  GetTicketSearchOptionsData,
  GetTicketSearchOptionsResponses,
  HrPortalFileLeaverData,
  HrPortalFileLeaverErrors,
  HrPortalFileLeaverResponses,
  HrPortalFileNewUserData,
  HrPortalFileNewUserErrors,
  HrPortalFileNewUserResponses,
  HrPortalPickUpData,
  HrPortalPickUpErrors,
  HrPortalPickUpResponses,
  ImportApproversData,
  ImportApproversErrors,
  ImportApproversResponses,
  ImportLegacyTicketData,
  ImportLegacyTicketErrors,
  ImportLegacyTicketResponses,
  JoinSimilarTicketData,
  JoinSimilarTicketErrors,
  JoinSimilarTicketResponses,
  LearnRoutingOutcomesData,
  LearnRoutingOutcomesResponses,
  ListAccessCaseActivityData,
  ListAccessCaseActivityErrors,
  ListAccessCaseActivityResponses,
  ListAccessCasesData,
  ListAccessCasesResponses,
  ListAccessCompletedData,
  ListAccessCompletedErrors,
  ListAccessCompletedResponses,
  ListApproverHistoryData,
  ListApproverHistoryErrors,
  ListApproverHistoryResponses,
  ListApproverRulesData,
  ListApproverRulesErrors,
  ListApproverRulesResponses,
  ListAssignTeamMembersData,
  ListAssignTeamMembersErrors,
  ListAssignTeamMembersResponses,
  ListAssignTeamsData,
  ListAssignTeamsResponses,
  ListConversationMessagesData,
  ListConversationMessagesErrors,
  ListConversationMessagesResponses,
  ListConversationsData,
  ListConversationsErrors,
  ListConversationsResponses,
  ListDemoPersonasData,
  ListDemoPersonasResponses,
  ListEmailIntakeData,
  ListEmailIntakeErrors,
  ListEmailIntakeResponses,
  ListKnowledgeAreasData,
  ListKnowledgeAreasResponses,
  ListKnowledgeArticlesData,
  ListKnowledgeArticlesErrors,
  ListKnowledgeArticlesResponses,
  ListKnowledgeImportsData,
  ListKnowledgeImportsResponses,
  ListKnowledgeVersionsData,
  ListKnowledgeVersionsErrors,
  ListKnowledgeVersionsResponses,
  ListMessageCodesData,
  ListMessageCodesResponses,
  ListMessagesData,
  ListMessagesErrors,
  ListMessagesResponses,
  ListMigrationHistoryData,
  ListMigrationHistoryResponses,
  ListMyAccessCasesData,
  ListMyAccessCasesResponses,
  ListMyApprovalsData,
  ListMyApprovalsResponses,
  ListNamedOnTicketsData,
  ListNamedOnTicketsErrors,
  ListNamedOnTicketsResponses,
  ListReportInsightTicketsData,
  ListReportInsightTicketsErrors,
  ListReportInsightTicketsResponses,
  ListReportSnapshotsData,
  ListReportSnapshotsErrors,
  ListReportSnapshotsResponses,
  ListRequestOfferingsData,
  ListRequestOfferingsErrors,
  ListRequestOfferingsResponses,
  ListRetiredApproversData,
  ListRetiredApproversResponses,
  ListRoleListsData,
  ListRoleListsResponses,
  ListRoutingAuditData,
  ListRoutingAuditErrors,
  ListRoutingAuditResponses,
  ListStarterCasesData,
  ListStarterCasesResponses,
  ListSupportedLanguagesData,
  ListSupportedLanguagesResponses,
  ListTeamsData,
  ListTeamsResponses,
  ListTicketsData,
  ListTicketsErrors,
  ListTicketsResponses,
  ListTicketTimelineData,
  ListTicketTimelineErrors,
  ListTicketTimelineResponses,
  LogoutData,
  LogoutResponses,
  LookupLegacyTicketData,
  LookupLegacyTicketErrors,
  LookupLegacyTicketResponses,
  MarkApproverNotApplicableData,
  MarkApproverNotApplicableErrors,
  MarkApproverNotApplicableResponses,
  PostAssistantMessageData,
  PostAssistantMessageErrors,
  PostAssistantMessageResponses,
  PrepareDemoPersonasData,
  PrepareDemoPersonasResponses,
  PrepareServiceRequestData,
  PrepareServiceRequestErrors,
  PrepareServiceRequestResponses,
  PreviewAccessApproversData,
  PreviewAccessApproversErrors,
  PreviewAccessApproversResponses,
  PreviewKnowledgeImportData,
  PreviewKnowledgeImportErrors,
  PreviewKnowledgeImportResponses,
  ReadKnowledgeArticleData,
  ReadKnowledgeArticleErrors,
  ReadKnowledgeArticleResponses,
  ReassignTicketData,
  ReassignTicketErrors,
  ReassignTicketResponses,
  RecordPageViewData,
  RecordPageViewErrors,
  RecordPageViewResponses,
  ReindexKnowledgeArticleData,
  ReindexKnowledgeArticleErrors,
  ReindexKnowledgeArticleResponses,
  ReindexKnowledgeData,
  ReindexKnowledgeResponses,
  RemoveDispatcherData,
  RemoveDispatcherErrors,
  RemoveDispatcherResponses,
  RemoveTeamMemberData,
  RemoveTeamMemberErrors,
  RemoveTeamMemberResponses,
  ReopenTicketData,
  ReopenTicketErrors,
  ReopenTicketResponses,
  ReportClientErrorData,
  ReportClientErrorErrors,
  ReportClientErrorResponses,
  ResetDemoPersonasData,
  ResetDemoPersonasErrors,
  ResetDemoPersonasResponses,
  RetireApproversData,
  RetireApproversErrors,
  RetireApproversResponses,
  RunAutoRouteData,
  RunAutoRouteErrors,
  RunAutoRouteResponses,
  RunEmailIntakeSamplesData,
  RunEmailIntakeSamplesErrors,
  RunEmailIntakeSamplesResponses,
  SearchDirectoryData,
  SearchDirectoryErrors,
  SearchDirectoryResponses,
  SearchTicketsData,
  SearchTicketsErrors,
  SearchTicketsResponses,
  SendTeamsBotTestCardData,
  SendTeamsBotTestCardResponses,
  SetApproverBackupData,
  SetApproverBackupErrors,
  SetApproverBackupResponses,
  SetApproverConfirmedData,
  SetApproverConfirmedErrors,
  SetApproverConfirmedResponses,
  SetApproverCoveringData,
  SetApproverCoveringErrors,
  SetApproverCoveringResponses,
  SetDispatcherAwayData,
  SetDispatcherAwayErrors,
  SetDispatcherAwayResponses,
  SetKnowledgeArticleStatusData,
  SetKnowledgeArticleStatusErrors,
  SetKnowledgeArticleStatusResponses,
  SetTeamsBotBackofficeChannelData,
  SetTeamsBotBackofficeChannelErrors,
  SetTeamsBotBackofficeChannelResponses,
  SetTeamsBotP1ChannelData,
  SetTeamsBotP1ChannelErrors,
  SetTeamsBotP1ChannelResponses,
  StartDemoPersonaData,
  StartDemoPersonaErrors,
  StartDemoPersonaResponses,
  StartViewAsData,
  StartViewAsErrors,
  StartViewAsResponses,
  StopViewAsData,
  StopViewAsResponses,
  StreamAssistantMessageData,
  StreamAssistantMessageErrors,
  StreamAssistantMessageResponse,
  StreamAssistantMessageResponses,
  SubmitAccessCaseData,
  SubmitAccessCaseErrors,
  SubmitAccessCaseResponses,
  SubmitFeedbackData,
  SubmitFeedbackErrors,
  SubmitFeedbackResponses,
  SubmitServiceRequestData,
  SubmitServiceRequestErrors,
  SubmitServiceRequestResponses,
  SuggestAssignmentData,
  SuggestAssignmentErrors,
  SuggestAssignmentResponses,
  UnmarkApproverNotApplicableData,
  UnmarkApproverNotApplicableErrors,
  UnmarkApproverNotApplicableResponses,
  UnretireApproversData,
  UnretireApproversErrors,
  UnretireApproversResponses,
  UpdateApproverRuleData,
  UpdateApproverRuleErrors,
  UpdateApproverRuleResponses,
  UpdateKnowledgeAreaData,
  UpdateKnowledgeAreaErrors,
  UpdateKnowledgeAreaResponses,
  UpdateKnowledgeArticleData,
  UpdateKnowledgeArticleErrors,
  UpdateKnowledgeArticleResponses,
  UpdateReportNowData,
  UpdateReportNowErrors,
  UpdateReportNowResponses,
  UpdateResourceOwnerData,
  UpdateResourceOwnerErrors,
  UpdateResourceOwnerResponses,
  UpdateRoutingRuleData,
  UpdateRoutingRuleErrors,
  UpdateRoutingRuleResponses,
  UpdateTeamData,
  UpdateTeamErrors,
  UpdateTeamResponses,
  UpdateTicketData,
  UpdateTicketErrors,
  UpdateTicketResponses,
  UploadDraftAttachmentData,
  UploadDraftAttachmentErrors,
  UploadDraftAttachmentResponses,
  UploadEmailIntakeMailData,
  UploadEmailIntakeMailErrors,
  UploadEmailIntakeMailResponses,
  UploadReportData,
  UploadReportErrors,
  UploadReportResponses,
  UploadTicketAttachmentData,
  UploadTicketAttachmentErrors,
  UploadTicketAttachmentResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * List Supported Languages
 *
 * List the languages the UI covers and the ones `translate_to` accepts.
 */
export const listSupportedLanguages = <ThrowOnError extends boolean = false>(
  options?: Options<ListSupportedLanguagesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListSupportedLanguagesResponses, unknown, ThrowOnError>({
    url: "/meta/languages",
    ...options,
  });

/**
 * List Message Codes
 *
 * List every stable machine code this API can emit.
 *
 * The frontend's CI asserts its translation catalogue covers this list, so a
 * new backend code fails the build rather than reaching a user untranslated.
 */
export const listMessageCodes = <ThrowOnError extends boolean = false>(
  options?: Options<ListMessageCodesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListMessageCodesResponses, unknown, ThrowOnError>({
    url: "/meta/message-codes",
    ...options,
  });

/**
 * Get Capabilities
 *
 * Report which implementations this deployment is actually running.
 *
 * `demo_knowledge_corpus` is always false here: this project has no
 * knowledge corpus at all (the assistant answers general IT questions from
 * the model), so nothing can be served from a seeded demo corpus. The field
 * stays for wire compatibility with the frontend's generated client.
 * `assistant` carries `ASSISTANT_MODE` and whether the real agent is running.
 * `ivanti_tier` names the tenant tickets land in, for the environment label.
 */
export const getCapabilities = <ThrowOnError extends boolean = false>(
  options?: Options<GetCapabilitiesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCapabilitiesResponses, unknown, ThrowOnError>({
    url: "/meta/capabilities",
    ...options,
  });

/**
 * Get Ticket Metadata
 *
 * Return the tenant's pick lists plus this service's upload limits.
 *
 * The attachment limits are the API's, not Ivanti's: the upload routes reject
 * an oversized or disallowed file before a byte reaches the provider, so the
 * form has to be told the same numbers the server will enforce.
 */
export const getTicketMetadata = <ThrowOnError extends boolean = false>(
  options?: Options<GetTicketMetadataData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetTicketMetadataResponses, unknown, ThrowOnError>({
    url: "/tickets/meta",
    ...options,
  });

/**
 * List Named On Tickets
 *
 * Service requests someone else raised that name the signed-in user.
 *
 * E.g. HR's New User Request naming them as the starter's manager
 * (`ReportingTo`). `named_as` is the person field; the UI labels it. Scoped
 * to the session like every other list here (2 Oct).
 */
export const listNamedOnTickets = <ThrowOnError extends boolean = false>(
  options?: Options<ListNamedOnTicketsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListNamedOnTicketsResponses,
    ListNamedOnTicketsErrors,
    ThrowOnError
  >({ url: "/tickets/named-on", ...options });

/**
 * Get Ticket By Number
 *
 * Read one ticket by its human-readable number, for deep links from email.
 *
 * A request that names the caller opens too, as the named view, so the link
 * in an Ivanti notification works for the manager as well.
 */
export const getTicketByNumber = <ThrowOnError extends boolean = false>(
  options: Options<GetTicketByNumberData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetTicketByNumberResponses, GetTicketByNumberErrors, ThrowOnError>(
    { url: "/tickets/by-number/{ticket_number}", ...options },
  );

/**
 * Upload Draft Attachment
 *
 * Upload a file before its ticket exists.
 *
 * The returned `attachment_id` goes into `createTicket.attachment_ids`.
 * Unclaimed drafts expire after `DRAFT_ATTACHMENT_TTL_SECONDS`.
 */
export const uploadDraftAttachment = <ThrowOnError extends boolean = false>(
  options: Options<UploadDraftAttachmentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UploadDraftAttachmentResponses,
    UploadDraftAttachmentErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/tickets/drafts/attachments",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * List Tickets
 *
 * List the signed-in user's own tickets.
 *
 * The requester filter is applied server-side from the session and is not
 * overridable: there is no query parameter that widens this beyond the caller.
 *
 * On a shared device (kiosk mode) the list is empty: the "caller" is the
 * site's generic person, whose tickets are everyone's at that site.
 */
export const listTickets = <ThrowOnError extends boolean = false>(
  options?: Options<ListTicketsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListTicketsResponses, ListTicketsErrors, ThrowOnError>({
    url: "/tickets",
    ...options,
  });

/**
 * Create Ticket
 *
 * Raise an incident, or submit a service request against an offering.
 *
 * `Idempotency-Key` is required and honoured: the key is reserved in
 * `ticket_idempotency` before Ivanti is called, so a double-submitted form or
 * a retried POST replays the original ticket instead of raising a second one.
 * The description is stored verbatim under `body_lang` and is never
 * translated on write (contract §3.6).
 *
 * Raised from an assistant conversation (`conversation_id`), the ticket also
 * gets the conversation as a journal note — after it exists, in the
 * background, and never at the cost of the create (`ticket_transcript`). A
 * replay returns before that is scheduled, so it is written once.
 *
 * `on_behalf_of_email` files an incident for a colleague (`on_behalf`): they
 * are the Customer, the description opens with who reported it, and an
 * address that is not an active employee is a 422 before anything is
 * reserved or written.
 *
 * Per-user ceilings (`rate_limits`) apply to every new create: a caller over
 * them gets `429 USER_QUOTA_EXCEEDED` and the key is released. An idempotent
 * replay is answered first, so a retry from a caller at the limit still gets
 * the ticket it already raised.
 *
 * On a shared device (kiosk mode) the person's name is required
 * (`KIOSK_NAME_REQUIRED`), the description opens with who raised it and
 * how to reach them, and "for a colleague" is refused (`KIOSK_NOT_ALLOWED`).
 */
export const createTicket = <ThrowOnError extends boolean = false>(
  options: Options<CreateTicketData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateTicketResponses, CreateTicketErrors, ThrowOnError>({
    url: "/tickets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Find Similar Tickets
 *
 * Is this the same problem? Open tickets about the same shared system (8 Oct).
 *
 * Asked by the incident form just before it files. Writes nothing. At most
 * three, each only a scrubbed subject, status, owner team, age and number
 * (`similar_tickets`). Empty when `SIMILAR_TICKETS_ENABLED` is off, on a
 * shared device, when nothing matches, or on any error: the form then
 * files as usual.
 */
export const findSimilarTickets = <ThrowOnError extends boolean = false>(
  options: Options<FindSimilarTicketsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    FindSimilarTicketsResponses,
    FindSimilarTicketsErrors,
    ThrowOnError
  >({
    url: "/tickets/similar",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Join Similar Ticket
 *
 * Yes, add me to it: note the person as affected on the open ticket; raise nothing.
 *
 * The ticket must be one the same report is offered right now (checked
 * again here, so no other ticket can be written to). The note is internal
 * (not published to the customer's portal) and written as the person:
 * "Also affected: <name> (<email>), via the HelpDesk", with their own
 * description. Once per person and ticket; a repeat answers the same
 * without writing again. Ivanti keeps emailing the ticket's customer only.
 */
export const joinSimilarTicket = <ThrowOnError extends boolean = false>(
  options: Options<JoinSimilarTicketData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    JoinSimilarTicketResponses,
    JoinSimilarTicketErrors,
    ThrowOnError
  >({
    url: "/tickets/similar/join",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Incident Followups
 *
 * Suggest a subject, a category and 0-3 follow-up questions for an incident.
 *
 * The "Continue" step of the incident form. Writes nothing. Never fails for
 * a model reason: with no model configured, or on a timeout or provider
 * error, it answers with no questions and a subject from the first line of
 * the description, and the form files straight away.
 *
 * Screenshots the caller has already uploaded as drafts are shown to the
 * model so it does not ask for what a picture already says. Ownership is
 * enforced inside `inline_images` — it returns nobody's bytes but the
 * caller's.
 */
export const getIncidentFollowups = <ThrowOnError extends boolean = false>(
  options: Options<GetIncidentFollowupsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GetIncidentFollowupsResponses,
    GetIncidentFollowupsErrors,
    ThrowOnError
  >({
    url: "/tickets/incident-followups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Ticket
 *
 * Read one ticket.
 *
 * Someone else's ticket is readable by a dev-bypass admin, and — read-only —
 * by the migrator who imported it (`viewed_as_migrator`), and — read and
 * comment only — by someone named on the request (`named_as`).
 */
export const getTicket = <ThrowOnError extends boolean = false>(
  options: Options<GetTicketData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetTicketResponses, GetTicketErrors, ThrowOnError>({
    url: "/tickets/{ticket_id}",
    ...options,
  });

/**
 * Update Ticket
 *
 * Amend a ticket's details. Never changes its status.
 */
export const updateTicket = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTicketData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateTicketResponses, UpdateTicketErrors, ThrowOnError>({
    url: "/tickets/{ticket_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Ticket Timeline
 *
 * Read a ticket's activity history. Internal agent notes are filtered out.
 *
 * Readable on the same terms as the ticket itself, migrator and named views
 * included — the same public entries the Customer sees.
 */
export const listTicketTimeline = <ThrowOnError extends boolean = false>(
  options: Options<ListTicketTimelineData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListTicketTimelineResponses,
    ListTicketTimelineErrors,
    ThrowOnError
  >({ url: "/tickets/{ticket_id}/timeline", ...options });

/**
 * Add Ticket Comment
 *
 * Append a comment to the ticket's journal, verbatim in `body_lang`.
 *
 * With files attached, the ticket is read first: that read is the ownership
 * check (`TICKET_NOT_YOURS`), and it has to happen before the caller's drafts
 * are rebound to `ticket_id` — otherwise naming someone else's ticket would
 * move the drafts onto it before `add_comment` refused. That read is
 * Customer-only on purpose: someone named on a request may comment, but not
 * attach files (2 Oct).
 */
export const addTicketComment = <ThrowOnError extends boolean = false>(
  options: Options<AddTicketCommentData, ThrowOnError>,
) =>
  (options.client ?? client).post<AddTicketCommentResponses, AddTicketCommentErrors, ThrowOnError>({
    url: "/tickets/{ticket_id}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Upload Ticket Attachment
 *
 * Attach a file to an existing ticket.
 *
 * The ticket is read first so the upload is refused when the caller may not
 * attach to it — the permission check is the provider's, not this route's.
 */
export const uploadTicketAttachment = <ThrowOnError extends boolean = false>(
  options: Options<UploadTicketAttachmentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UploadTicketAttachmentResponses,
    UploadTicketAttachmentErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/tickets/{ticket_id}/attachments",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Get Ticket Attachment Download
 *
 * Return a short-lived, single-use descriptor for an attachment's bytes.
 *
 * The SDK stays JSON-only; the browser navigates to `url_path` to fetch the
 * file itself.
 *
 * A file Ivanti holds (an upper-case RecId: one IT added in the console, or
 * one already pushed from here, 19 Oct) points at `/files/{id}` instead,
 * which re-checks on every read that this reader may see the ticket and
 * that the file is one the ticket page shows them.
 */
export const getTicketAttachmentDownload = <ThrowOnError extends boolean = false>(
  options: Options<GetTicketAttachmentDownloadData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetTicketAttachmentDownloadResponses,
    GetTicketAttachmentDownloadErrors,
    ThrowOnError
  >({ url: "/tickets/{ticket_id}/attachments/{attachment_id}", ...options });

/**
 * Answer Ticket Info Request
 *
 * Answer an agent's request for more information.
 *
 * Composed from the journal write plus locally recorded state, because Ivanti
 * has no dedicated quick action for this yet — see
 * `api/services/ticket_overlay.py` for why the state is tracked at all.
 */
export const answerTicketInfoRequest = <ThrowOnError extends boolean = false>(
  options: Options<AnswerTicketInfoRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AnswerTicketInfoRequestResponses,
    AnswerTicketInfoRequestErrors,
    ThrowOnError
  >({
    url: "/tickets/{ticket_id}/info-requests/{info_request_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Close Ticket
 *
 * Close a ticket at the user's request ("this is sorted").
 */
export const closeTicket = <ThrowOnError extends boolean = false>(
  options: Options<CloseTicketData, ThrowOnError>,
) =>
  (options.client ?? client).post<CloseTicketResponses, CloseTicketErrors, ThrowOnError>({
    url: "/tickets/{ticket_id}/close",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confirm Ticket Resolution
 *
 * Accept or reject an agent's proposed resolution.
 *
 * Refused outright while the portal cannot perform the transition. Rejecting
 * was only ever a journal post — the docstring used to say that "reopens the
 * conversation with the agent", which is true of the conversation and not of
 * the ticket: it stayed Resolved and went on to auto-close. Saying so to a
 * user who has just reported the problem is not fixed is the untruth this
 * check removes.
 */
export const confirmTicketResolution = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmTicketResolutionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ConfirmTicketResolutionResponses,
    ConfirmTicketResolutionErrors,
    ThrowOnError
  >({
    url: "/tickets/{ticket_id}/resolution-confirmation",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reopen Ticket
 *
 * Reopen a resolved ticket, stating why.
 *
 * Refused outright while the portal cannot perform the transition. The body
 * below posts a comment and re-reads the ticket — it never writes Status, and
 * for a long time it reported success anyway, over a ticket that was still
 * Resolved. It is kept behind the capability check rather than deleted
 * because it is most of the flow; what it is not allowed to do is run and
 * call the result a reopen.
 */
export const reopenTicket = <ThrowOnError extends boolean = false>(
  options: Options<ReopenTicketData, ThrowOnError>,
) =>
  (options.client ?? client).post<ReopenTicketResponses, ReopenTicketErrors, ThrowOnError>({
    url: "/tickets/{ticket_id}/reopen",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Request Offerings
 *
 * List the service catalog entries published to this user.
 */
export const listRequestOfferings = <ThrowOnError extends boolean = false>(
  options?: Options<ListRequestOfferingsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListRequestOfferingsResponses,
    ListRequestOfferingsErrors,
    ThrowOnError
  >({ url: "/catalog/offerings", ...options });

/**
 * Get Request Offering
 *
 * Read one offering with its form definition resolved.
 */
export const getRequestOffering = <ThrowOnError extends boolean = false>(
  options: Options<GetRequestOfferingData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetRequestOfferingResponses,
    GetRequestOfferingErrors,
    ThrowOnError
  >({ url: "/catalog/offerings/{offering_id}", ...options });

/**
 * List Role Lists
 *
 * The role pickers of the Master approval matrix (8 Oct): 365FO, Bluestar, Power BI.
 *
 * A shipped file, the same for everyone; signed in only. The forms use
 * Bluestar's areas for "Roles or access needed" when the system is Bluestar.
 */
export const listRoleLists = <ThrowOnError extends boolean = false>(
  options?: Options<ListRoleListsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListRoleListsResponses, unknown, ThrowOnError>({
    url: "/catalog/role-lists",
    ...options,
  });

/**
 * Search Directory
 *
 * Search colleagues by name or email, best matches first.
 *
 * `q` is required and must be at least one character: an unfiltered directory
 * is 1,663 rows and is not a useful answer to a keystroke.
 *
 * Returns:
 * Ranked hits — display-name prefix, then word prefix, then substring,
 * alphabetical within each tier — each carrying the manager resolved from
 * the same cached directory. `truncated` is true when more people matched
 * than `limit` allowed, so the UI can say "keep typing" rather than
 * implying the list is complete.
 */
export const searchDirectory = <ThrowOnError extends boolean = false>(
  options: Options<SearchDirectoryData, ThrowOnError>,
) =>
  (options.client ?? client).get<SearchDirectoryResponses, SearchDirectoryErrors, ThrowOnError>({
    url: "/directory/employees",
    ...options,
  });

/**
 * List Assistant Conversations
 *
 * List the caller's conversations, most recent activity first.
 *
 * Empty on a shared device (kiosk mode): its conversations belong to the
 * site's generic person, so they are everyone's at that site.
 */
export const listConversations = <ThrowOnError extends boolean = false>(
  options?: Options<ListConversationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListConversationsResponses,
    ListConversationsErrors,
    ThrowOnError
  >({ url: "/assistant/conversations", ...options });

/**
 * Create Assistant Conversation
 *
 * Start a conversation. Context here is provenance only, never access.
 */
export const createConversation = <ThrowOnError extends boolean = false>(
  options: Options<CreateConversationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateConversationResponses,
    CreateConversationErrors,
    ThrowOnError
  >({
    url: "/assistant/conversations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Assistant Conversation
 *
 * Soft-delete a conversation: invisible immediately, retained for audit.
 */
export const deleteConversation = <ThrowOnError extends boolean = false>(
  options: Options<DeleteConversationData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteConversationResponses,
    DeleteConversationErrors,
    ThrowOnError
  >({ url: "/assistant/conversations/{conversation_id}", ...options });

/**
 * Get Assistant Conversation
 *
 * Read one conversation with a page of its messages.
 */
export const getConversation = <ThrowOnError extends boolean = false>(
  options: Options<GetConversationData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetConversationResponses, GetConversationErrors, ThrowOnError>({
    url: "/assistant/conversations/{conversation_id}",
    ...options,
  });

/**
 * List Assistant Messages
 *
 * List the messages in one conversation.
 */
export const listConversationMessages = <ThrowOnError extends boolean = false>(
  options: Options<ListConversationMessagesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListConversationMessagesResponses,
    ListConversationMessagesErrors,
    ThrowOnError
  >({ url: "/assistant/conversations/{conversation_id}/messages", ...options });

/**
 * Post Assistant Message
 *
 * Enqueue the user's turn and reserve the assistant's reply.
 *
 * Returns immediately. The model call happens in the background; follow it on
 * `stream_path`, or poll `getAssistantMessage` if the client cannot hold an
 * SSE connection open.
 *
 * Past `RATE_LIMIT_ASSISTANT_TURNS_PER_10_MINUTES` turns the caller gets
 * `429 USER_QUOTA_EXCEEDED` and nothing is written.
 */
export const postAssistantMessage = <ThrowOnError extends boolean = false>(
  options: Options<PostAssistantMessageData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAssistantMessageResponses,
    PostAssistantMessageErrors,
    ThrowOnError
  >({
    url: "/assistant/conversations/{conversation_id}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Stream Assistant Message
 *
 * Stream one assistant reply as `text/event-stream`.
 *
 * Reconnect-safe: every event carries an `id:`, and a client that reconnects
 * with `Last-Event-ID` resumes from the next sequence. A stream opened against
 * an already-finished reply replays what this process still holds, or falls
 * back to a single `done` event rebuilt from the database — or, when that row
 * is still unfinished, a single recoverable `error` event.
 */
export const streamAssistantMessage = <ThrowOnError extends boolean = false>(
  options: Options<StreamAssistantMessageData, ThrowOnError, StreamAssistantMessageResponse>,
) =>
  (options.client ?? client).sse.get<
    StreamAssistantMessageResponses,
    StreamAssistantMessageErrors,
    ThrowOnError
  >({ url: "/assistant/conversations/{conversation_id}/messages/{message_id}/stream", ...options });

/**
 * Cancel Assistant Message
 *
 * Stop an in-flight reply. Idempotent.
 */
export const cancelAssistantMessage = <ThrowOnError extends boolean = false>(
  options: Options<CancelAssistantMessageData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CancelAssistantMessageResponses,
    CancelAssistantMessageErrors,
    ThrowOnError
  >({ url: "/assistant/conversations/{conversation_id}/messages/{message_id}/cancel", ...options });

/**
 * Get Assistant Message
 *
 * Read one message. The polling fallback for clients without SSE.
 */
export const getAssistantMessage = <ThrowOnError extends boolean = false>(
  options: Options<GetAssistantMessageData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAssistantMessageResponses,
    GetAssistantMessageErrors,
    ThrowOnError
  >({ url: "/assistant/conversations/{conversation_id}/messages/{message_id}", ...options });

/**
 * Prepare Service Request
 *
 * Validate a filled-in offering form and hold it for confirmation.
 *
 * Writes nothing — not to Ivanti, not to the database. Every answer is
 * re-checked here against the offering's own parameter definitions, read
 * fresh for this user, because the form the browser is holding was captured
 * when the assistant rendered it and the catalog may have moved since.
 *
 * A rejection is a `200` carrying `field_errors`, not a `4xx`. The request
 * was understood and correctly refused, and the per-field detail is the whole
 * value of the answer; an error status would route it through the frontend's
 * generic error path and lose it.
 *
 * The validation is `it_helpdesk_agent.api.services.service_requests`, the same code
 * the assistant's `prepare_service_request` tool runs. There is deliberately
 * no second copy: two validators in front of one Ivanti write drift, and this
 * one decides what gets filed in somebody's name.
 */
export const prepareServiceRequest = <ThrowOnError extends boolean = false>(
  options: Options<PrepareServiceRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PrepareServiceRequestResponses,
    PrepareServiceRequestErrors,
    ThrowOnError
  >({
    url: "/assistant/service-requests/prepare",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Submit Service Request
 *
 * File a prepared request, and only report it filed when it exists.
 *
 * Three separate refusals guard this, in order:
 *
 * 1. `user_confirmed` must be true. A person pressed the button, or nothing
 * happens.
 * 2. `Idempotency-Key` is reserved before Ivanti is called, exactly as
 * `createTicket` does it, so a double click replays the first request
 * instead of raising a twin.
 * 3. The draft must still be live and belong to the caller. It is redeemed on
 * success, so the same `draft_id` cannot be filed twice under two keys.
 *
 * What comes back from Ivanti is then checked rather than assumed.
 * `POST /api/rest/ServiceRequest/new` reports failure *inside* a `200` body
 * (`IsSuccess: false`), and has separately been seen answering `200` while
 * creating nothing at all — `_require_submission_accepted()` catches the
 * first and `_find_recently_submitted()` the second. On this tenant the
 * endpoint currently rejects every submission; see the BLOCKER section of
 * `docs/ivanti-schema-verified.md`. The refusal reaches the caller with
 * Ivanti's own `ErrorText` attached. Nothing here ever answers "submitted"
 * for a request that does not exist.
 *
 * On a shared device (kiosk mode) the person's name is required and opens
 * the request's description (`kiosk.require_raised_by_line`).
 */
export const submitServiceRequest = <ThrowOnError extends boolean = false>(
  options: Options<SubmitServiceRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SubmitServiceRequestResponses,
    SubmitServiceRequestErrors,
    ThrowOnError
  >({
    url: "/assistant/service-requests/submit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Messages
 *
 * Notices this employee should see, lowest rank first, then newest.
 *
 * `?placement=HOME` is what the Ask landing page asks for; the Message Center
 * itself omits it and gets HOME and CENTER together.
 */
export const listMessages = <ThrowOnError extends boolean = false>(
  options?: Options<ListMessagesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListMessagesResponses, ListMessagesErrors, ThrowOnError>({
    url: "/messages",
    ...options,
  });

/**
 * Get Message
 *
 * One notice in full.
 *
 * The lists carry headlines; a notice long enough to need reading gets its
 * own page rather than unrolling itself on the landing page of everyone in
 * the group. No sync here — a notice reached by its own URL was listed a
 * moment ago, and re-running the mirror on every read would cost a tenant
 * call per click.
 */
export const getMessage = <ThrowOnError extends boolean = false>(
  options: Options<GetMessageData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetMessageResponses, GetMessageErrors, ThrowOnError>({
    url: "/messages/{message_id}",
    ...options,
  });

/**
 * Admin List Messages
 *
 * Every notice, drafts and hidden ones included.
 */
export const adminListMessages = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListMessagesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AdminListMessagesResponses, unknown, ThrowOnError>({
    url: "/admin/messages",
    ...options,
  });

/**
 * Admin Create Message
 *
 * Write a new LOCAL notice. Created unpublished — publishing is a PATCH.
 */
export const adminCreateMessage = <ThrowOnError extends boolean = false>(
  options: Options<AdminCreateMessageData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminCreateMessageResponses,
    AdminCreateMessageErrors,
    ThrowOnError
  >({
    url: "/admin/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Delete Message
 *
 * Delete a LOCAL notice. A mirrored one is a 409 — hide it instead.
 */
export const adminDeleteMessage = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteMessageData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    AdminDeleteMessageResponses,
    AdminDeleteMessageErrors,
    ThrowOnError
  >({ url: "/admin/messages/{message_id}", ...options });

/**
 * Admin Update Message
 *
 * Edit one notice.
 *
 * On an IVANTI row only `placement` and `rank` are ours; anything else is a
 * 409. A placement change appends to the history in the same transaction.
 */
export const adminUpdateMessage = <ThrowOnError extends boolean = false>(
  options: Options<AdminUpdateMessageData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    AdminUpdateMessageResponses,
    AdminUpdateMessageErrors,
    ThrowOnError
  >({
    url: "/admin/messages/{message_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Message History
 *
 * The placement history of one notice — who moved it, when, and from where.
 */
export const adminMessageHistory = <ThrowOnError extends boolean = false>(
  options: Options<AdminMessageHistoryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    AdminMessageHistoryResponses,
    AdminMessageHistoryErrors,
    ThrowOnError
  >({ url: "/admin/messages/{message_id}/history", ...options });

/**
 * Submit Feedback
 *
 * Record the caller's verdict on one of their assistant replies, replacing any earlier one.
 *
 * A thumbs-up carries no reasons and no comment: they explain a miss, and a
 * change of mind from 👎 to 👍 should not leave the old complaint behind.
 *
 * Raises:
 * ApiError: 404 `FEEDBACK_TARGET_NOT_FOUND` when there is no ratable reply
 * by that id, including one in someone else's conversation (a 403
 * would confirm the id exists).
 */
export const submitFeedback = <ThrowOnError extends boolean = false>(
  options: Options<SubmitFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).post<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError>({
    url: "/feedback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Feedback
 *
 * The latest feedback on assistant replies, newest change first.
 *
 * `status` keeps the open or the resolved items (9 Oct); `counts` is open vs
 * resolved for the same rating filter, whatever `status` is.
 */
export const adminListFeedback = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListFeedbackData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminListFeedbackResponses,
    AdminListFeedbackErrors,
    ThrowOnError
  >({ url: "/admin/feedback", ...options });

/**
 * Admin Get Feedback Summary
 *
 * Thumbs up vs thumbs down over the last 7 and 30 days, and the auto-logged errors.
 *
 * `since` (ISO 8601) bounds the `errors` block; it defaults to the last 24
 * hours. Read-only, for reporting.
 */
export const adminGetFeedbackSummary = <ThrowOnError extends boolean = false>(
  options?: Options<AdminGetFeedbackSummaryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminGetFeedbackSummaryResponses,
    AdminGetFeedbackSummaryErrors,
    ThrowOnError
  >({ url: "/admin/feedback/summary", ...options });

/**
 * Report Client Error
 *
 * Log a failure the browser saw (a request with no answer, a crashed screen) as feedback.
 *
 * Rate-limited per person (`CLIENT_REPORTS_PER_WINDOW` per ten minutes):
 * a page stuck in a crash loop is one problem, not a flood. Never an error:
 * a dropped report answers `logged: false`.
 */
export const reportClientError = <ThrowOnError extends boolean = false>(
  options: Options<ReportClientErrorData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ReportClientErrorResponses,
    ReportClientErrorErrors,
    ThrowOnError
  >({
    url: "/feedback/client-error",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Error Feedback
 *
 * The Errors (auto-logged) view: one row per error and endpoint, newest first.
 *
 * `ref` keeps only the error a person quoted ("Ref. 7F3A12BC"), as the Teams
 * card links it. `status` keeps the open or the resolved groups (9 Oct); a
 * group that came back after its fix is open again.
 */
export const adminListErrorFeedback = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListErrorFeedbackData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminListErrorFeedbackResponses,
    AdminListErrorFeedbackErrors,
    ThrowOnError
  >({ url: "/admin/feedback/errors", ...options });

/**
 * Admin Resolve Feedback
 *
 * Mark an inbox item resolved with a fix note ("PR #83 – retry before logging").
 *
 * Resolving one that already is replaces its note. An error group is
 * resolved for everyone who hit it; if the same error comes back it reopens
 * by itself, marked "came back".
 *
 * Raises:
 * ApiError: 404 `FEEDBACK_TARGET_NOT_FOUND` when there is no such item.
 */
export const adminResolveFeedback = <ThrowOnError extends boolean = false>(
  options: Options<AdminResolveFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminResolveFeedbackResponses,
    AdminResolveFeedbackErrors,
    ThrowOnError
  >({
    url: "/admin/feedback/resolve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Reopen Feedback
 *
 * Reopen a resolved inbox item; its fix note stays in the history.
 *
 * Reopening an item that is already open changes nothing.
 *
 * Raises:
 * ApiError: 404 `FEEDBACK_TARGET_NOT_FOUND` when there is no such item.
 */
export const adminReopenFeedback = <ThrowOnError extends boolean = false>(
  options: Options<AdminReopenFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminReopenFeedbackResponses,
    AdminReopenFeedbackErrors,
    ThrowOnError
  >({
    url: "/admin/feedback/reopen",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Recent Fixes
 *
 * The latest distinct fix notes and the PR numbers in them (the dialog's quick picks).
 */
export const adminListRecentFixes = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListRecentFixesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AdminListRecentFixesResponses, unknown, ThrowOnError>({
    url: "/admin/feedback/recent-fixes",
    ...options,
  });

/**
 * Get Migrate Status
 *
 * Whether the legacy CRM can be read as this migrator, and how to connect if not.
 */
export const getMigrateStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetMigrateStatusData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMigrateStatusResponses, unknown, ThrowOnError>({
    url: "/migrate/status",
    ...options,
  });

/**
 * Lookup Legacy Ticket
 *
 * Read one legacy ticket (read-only) and suggest how it goes into the ITSM.
 *
 * Also says whether it was already migrated (`already_migrated`), in which
 * case the UI stops there. Writes nothing anywhere.
 */
export const lookupLegacyTicket = <ThrowOnError extends boolean = false>(
  options: Options<LookupLegacyTicketData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    LookupLegacyTicketResponses,
    LookupLegacyTicketErrors,
    ThrowOnError
  >({
    url: "/migrate/lookup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Migrate Request Form
 *
 * The offering's form, prefilled from the legacy ticket and the chosen customer.
 */
export const getMigrateRequestForm = <ThrowOnError extends boolean = false>(
  options: Options<GetMigrateRequestFormData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GetMigrateRequestFormResponses,
    GetMigrateRequestFormErrors,
    ThrowOnError
  >({
    url: "/migrate/request-form",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Import Legacy Ticket
 *
 * Create the ITSM ticket for a legacy ticket, with its history as one internal note.
 *
 * Idempotent on `legacy_number`, across every migrator: a second import (or
 * a retried POST) returns the first one's ticket as `already_migrated` and
 * writes nothing. `Idempotency-Key` is required as on `createTicket`; the
 * arbitration itself is on the legacy number. Exempt from the per-user
 * ticket-creation ceilings.
 */
export const importLegacyTicket = <ThrowOnError extends boolean = false>(
  options: Options<ImportLegacyTicketData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ImportLegacyTicketResponses,
    ImportLegacyTicketErrors,
    ThrowOnError
  >({
    url: "/migrate/import",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Migration History
 *
 * The signed-in migrator's last 50 imports, newest first.
 */
export const listMigrationHistory = <ThrowOnError extends boolean = false>(
  options?: Options<ListMigrationHistoryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListMigrationHistoryResponses, unknown, ThrowOnError>({
    url: "/migrate/history",
    ...options,
  });

/**
 * Record Page View
 *
 * Record how long the caller had a page visible. Always 204.
 */
export const recordPageView = <ThrowOnError extends boolean = false>(
  options: Options<RecordPageViewData, ThrowOnError>,
) =>
  (options.client ?? client).post<RecordPageViewResponses, RecordPageViewErrors, ThrowOnError>({
    url: "/usage/page-views",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Get Usage Summary
 *
 * Active users, sign-ins, chats, tickets and time on page over the last `days` days.
 */
export const adminGetUsageSummary = <ThrowOnError extends boolean = false>(
  options?: Options<AdminGetUsageSummaryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminGetUsageSummaryResponses,
    AdminGetUsageSummaryErrors,
    ThrowOnError
  >({ url: "/admin/usage/summary", ...options });

/**
 * Admin List Sign Ins
 *
 * Entra sign-in attempts to this app, newest first.
 */
export const adminListSignIns = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListSignInsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AdminListSignInsResponses, AdminListSignInsErrors, ThrowOnError>({
    url: "/admin/usage/sign-ins",
    ...options,
  });

/**
 * Admin List Raised Tickets
 *
 * Tickets this app raised since `since` (default: midnight UTC today).
 *
 * The browser sends its own local midnight, so "today" is the admin's day.
 * Anything older than `TICKETS_MAX_LOOKBACK` is clamped to it.
 */
export const adminListRaisedTickets = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListRaisedTicketsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminListRaisedTicketsResponses,
    AdminListRaisedTicketsErrors,
    ThrowOnError
  >({ url: "/admin/usage/tickets", ...options });

/**
 * Admin Get Agent Status
 *
 * Green, amber or red for the AI model, Ivanti and this API, and the running release.
 */
export const adminGetAgentStatus = <ThrowOnError extends boolean = false>(
  options?: Options<AdminGetAgentStatusData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AdminGetAgentStatusResponses, unknown, ThrowOnError>({
    url: "/admin/usage/status",
    ...options,
  });

/**
 * Get Teams Bot Status
 *
 * The bot's status: switched on, Bot ID and secret set (yes/no), installs, the P1 channel.
 */
export const getTeamsBotStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetTeamsBotStatusData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetTeamsBotStatusResponses, unknown, ThrowOnError>({
    url: "/admin/teams-bot",
    ...options,
  });

/**
 * Set Teams Bot P1 Channel
 *
 * Choose the channel P1 cards go to (one the bot is in), or clear it (null).
 */
export const setTeamsBotP1Channel = <ThrowOnError extends boolean = false>(
  options: Options<SetTeamsBotP1ChannelData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    SetTeamsBotP1ChannelResponses,
    SetTeamsBotP1ChannelErrors,
    ThrowOnError
  >({
    url: "/admin/teams-bot/p1-channel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set Teams Bot Backoffice Channel
 *
 * Choose the channel Backoffice's "new user ready" cards go to (21 Oct), or clear it.
 */
export const setTeamsBotBackofficeChannel = <ThrowOnError extends boolean = false>(
  options: Options<SetTeamsBotBackofficeChannelData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    SetTeamsBotBackofficeChannelResponses,
    SetTeamsBotBackofficeChannelErrors,
    ThrowOnError
  >({
    url: "/admin/teams-bot/backoffice-channel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Send Teams Bot Test Card
 *
 * Send the welcome card to the signed-in admin's own Teams chat with the bot.
 */
export const sendTeamsBotTestCard = <ThrowOnError extends boolean = false>(
  options?: Options<SendTeamsBotTestCardData, ThrowOnError>,
) =>
  (options?.client ?? client).post<SendTeamsBotTestCardResponses, unknown, ThrowOnError>({
    url: "/admin/teams-bot/test-card",
    ...options,
  });

/**
 * List Teams
 *
 * The teams this person may see: all for an admin or IT, their own for a manager.
 */
export const listTeams = <ThrowOnError extends boolean = false>(
  options?: Options<ListTeamsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListTeamsResponses, unknown, ThrowOnError>({
    url: "/teams",
    ...options,
  });

/**
 * Get Team
 *
 * One team with members and problems. 404 if none, 403 if you may not see it.
 *
 * `can_edit` says whether this caller may change it (admin, or its manager).
 */
export const getTeam = <ThrowOnError extends boolean = false>(
  options: Options<GetTeamData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetTeamResponses, GetTeamErrors, ThrowOnError>({
    url: "/teams/{team_id}",
    ...options,
  });

/**
 * Update Team
 *
 * Change the team email and/or the manager; omitted fields are left alone.
 *
 * A manager may hand their own team to someone else; unless they are an
 * admin, that ends their access to it (the page warns before sending).
 */
export const updateTeam = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTeamData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateTeamResponses, UpdateTeamErrors, ThrowOnError>({
    url: "/teams/{team_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add Team Member
 *
 * Add an employee (by RecId, from the directory search). Already a member: no-op.
 */
export const addTeamMember = <ThrowOnError extends boolean = false>(
  options: Options<AddTeamMemberData, ThrowOnError>,
) =>
  (options.client ?? client).post<AddTeamMemberResponses, AddTeamMemberErrors, ThrowOnError>({
    url: "/teams/{team_id}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove Team Member
 *
 * Remove a member from the team (the employee record itself is untouched).
 */
export const removeTeamMember = <ThrowOnError extends boolean = false>(
  options: Options<RemoveTeamMemberData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    RemoveTeamMemberResponses,
    RemoveTeamMemberErrors,
    ThrowOnError
  >({ url: "/teams/{team_id}/members/{employee_id}", ...options });

/**
 * List Starter Cases
 *
 * The new starter cases the signed-in person may see, latest start date first.
 *
 * Each carries its stage tracker and the reader's own next actions
 * ("Action for you"). `result` says when a read did not answer in full.
 */
export const listStarterCases = <ThrowOnError extends boolean = false>(
  options?: Options<ListStarterCasesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListStarterCasesResponses, unknown, ThrowOnError>({
    url: "/starters",
    ...options,
  });

/**
 * Get Starter Case
 *
 * One case, read fresh from Ivanti. 403 when the reader is not involved.
 *
 * A read is also when the "account ready" note is checked for this case:
 * in the background, so the page never waits on it.
 */
export const getStarterCase = <ThrowOnError extends boolean = false>(
  options: Options<GetStarterCaseData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetStarterCaseResponses, GetStarterCaseErrors, ThrowOnError>({
    url: "/starters/{case_id}",
    ...options,
  });

/**
 * Confirm Starter Account
 *
 * Confirm which directory person is the starter (the NUR owner, their team, admins).
 *
 * One of the case's current candidates; or, with `from_directory`, anyone
 * from the directory while the account is not known (5 Oct). Writes an
 * internal note on the NUR naming the Employee RecId; the gate reads it back.
 */
export const confirmStarterAccount = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmStarterAccountData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ConfirmStarterAccountResponses,
    ConfirmStarterAccountErrors,
    ThrowOnError
  >({
    url: "/starters/{case_id}/confirm-account",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Starter Prefill
 *
 * The offering and answers to open a step's request form with, past the gate.
 *
 * The form stays the person's to review and submit; fields or options the
 * offering does not have are left out, never invented.
 */
export const getStarterPrefill = <ThrowOnError extends boolean = false>(
  options: Options<GetStarterPrefillData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetStarterPrefillResponses, GetStarterPrefillErrors, ThrowOnError>(
    { url: "/starters/{case_id}/prefill/{step}", ...options },
  );

/**
 * Get Access Catalog
 *
 * The checklist, as the signed-in person's own catalog offers it.
 *
 * An item whose form is not published to them comes back without an
 * offering id, so the wizard can say so instead of failing at Send.
 */
export const getAccessCatalog = <ThrowOnError extends boolean = false>(
  options?: Options<GetAccessCatalogData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetAccessCatalogResponses, unknown, ThrowOnError>({
    url: "/access/catalog",
    ...options,
  });

/**
 * Get Access Prefill
 *
 * One item's form, opened with what the wizard knows (a read; POST for its body).
 *
 * Fields or options the offering does not have are left out, never invented.
 * For a new hire, the fields the app fills at release are listed in
 * `held_parameter_ids` so the form can leave them out.
 */
export const getAccessPrefill = <ThrowOnError extends boolean = false>(
  options: Options<GetAccessPrefillData, ThrowOnError>,
) =>
  (options.client ?? client).post<GetAccessPrefillResponses, GetAccessPrefillErrors, ThrowOnError>({
    url: "/access/prefill",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Access Cases
 *
 * The access cases the signed-in person may see, newest first.
 */
export const listAccessCases = <ThrowOnError extends boolean = false>(
  options?: Options<ListAccessCasesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListAccessCasesResponses, unknown, ThrowOnError>({
    url: "/access/cases",
    ...options,
  });

/**
 * Submit Access Case
 *
 * Send. New files the New User Request and holds the rest; Change files every item.
 *
 * `Idempotency-Key` covers every item: sending the same case again replays
 * what was filed and retries only what failed.
 *
 * 7 Oct: 409 `ACCESS_CASE_DUPLICATE` when an open case of the same type
 * exists for the person (`params` name it: existing_case_id,
 * request_number, type, started_at, requester_name, ...). A New matched by
 * name only may be sent anyway with `override_duplicate` by IT or an admin
 * (403 for anyone else); the override is noted on the new case.
 *
 * 28 Oct (Rusty): 403 `ACCESS_HR_PORTAL_ONLY` for a type the HelpDesk does
 * not start (`ACCESS_HELPDESK_STARTS`, default "change"): HR starts New
 * users and Leavers in the HR Portal. Nothing is filed.
 */
export const submitAccessCase = <ThrowOnError extends boolean = false>(
  options: Options<SubmitAccessCaseData, ThrowOnError>,
) =>
  (options.client ?? client).post<SubmitAccessCaseResponses, SubmitAccessCaseErrors, ThrowOnError>({
    url: "/access/cases",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Check Access Duplicate
 *
 * The wizard's check while the person is entered (7 Oct): is there an open case?
 *
 * New: by the hire's name (case, spaces and accents ignored). Change and
 * Leave: by the employee (`person_id`; a Change without one is the
 * requester). Says whether the reader may override a match by name.
 */
export const checkAccessDuplicate = <ThrowOnError extends boolean = false>(
  options: Options<CheckAccessDuplicateData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    CheckAccessDuplicateResponses,
    CheckAccessDuplicateErrors,
    ThrowOnError
  >({ url: "/access/duplicate", ...options });

/**
 * List My Access Cases
 *
 * The cases the signed-in person is involved in, as My Tickets rows (6 Oct).
 *
 * The requester, the person, the manager, anyone named, the step owners and
 * the approvers; not every case an admin may see. Each row carries its
 * requests, which My Tickets groups under it instead of listing them.
 */
export const listMyAccessCases = <ThrowOnError extends boolean = false>(
  options?: Options<ListMyAccessCasesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListMyAccessCasesResponses, unknown, ThrowOnError>({
    url: "/access/mine",
    ...options,
  });

/**
 * Get Access Case
 *
 * One case, with each item's team, status and approvals. 403 when not involved.
 */
export const getAccessCase = <ThrowOnError extends boolean = false>(
  options: Options<GetAccessCaseData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetAccessCaseResponses, GetAccessCaseErrors, ThrowOnError>({
    url: "/access/cases/{case_id}",
    ...options,
  });

/**
 * List Access Case Activity
 *
 * The case's comments and activity (22 Oct): the anchor request's public journal.
 *
 * Whoever may see the case (403 otherwise) reads it, as the case page shows
 * it; internal notes never come back. The latest entries, oldest first.
 */
export const listAccessCaseActivity = <ThrowOnError extends boolean = false>(
  options: Options<ListAccessCaseActivityData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListAccessCaseActivityResponses,
    ListAccessCaseActivityErrors,
    ThrowOnError
  >({ url: "/access/cases/{case_id}/activity", ...options });

/**
 * Add Access Case Comment
 *
 * Comment on the case (22 Oct, Rusty): a public journal note on its anchor request.
 *
 * The anchor is the Access - New user request, the Change case or the
 * Leaver. Anyone who may see the case (403 otherwise): the manager, the
 * requester, the teams with a step, approvers, admins. Written as the
 * ticket page's comment is (`addTicketComment`): as the caller, signed in a
 * demo, and a reply on a finished request reopens it or tells its owner.
 * No files. 409 while the case has no request in ITSM.
 */
export const addAccessCaseComment = <ThrowOnError extends boolean = false>(
  options: Options<AddAccessCaseCommentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AddAccessCaseCommentResponses,
    AddAccessCaseCommentErrors,
    ThrowOnError
  >({
    url: "/access/cases/{case_id}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Access Item Prefill
 *
 * "Open prefilled": a held item's form, with its answers and the new hire.
 */
export const getAccessItemPrefill = <ThrowOnError extends boolean = false>(
  options: Options<GetAccessItemPrefillData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAccessItemPrefillResponses,
    GetAccessItemPrefillErrors,
    ThrowOnError
  >({ url: "/access/cases/{case_id}/items/{n}/prefill", ...options });

/**
 * File Access Item
 *
 * File a held item by hand. Writes its release marker, so the app never files it too.
 */
export const fileAccessItem = <ThrowOnError extends boolean = false>(
  options: Options<FileAccessItemData, ThrowOnError>,
) =>
  (options.client ?? client).post<FileAccessItemResponses, FileAccessItemErrors, ThrowOnError>({
    url: "/access/cases/{case_id}/items/{n}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Access Resource Owner
 *
 * Who approves a new hire's software or folder first (13 Oct): "Check and send" says so.
 *
 * The owner listed for it in Resource owners, as Send asks them; nobody for
 * an unlisted one (Global IT Helpdesk just sets it up with the account).
 */
export const getAccessResourceOwner = <ThrowOnError extends boolean = false>(
  options: Options<GetAccessResourceOwnerData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAccessResourceOwnerResponses,
    GetAccessResourceOwnerErrors,
    ThrowOnError
  >({ url: "/access/resource-owner", ...options });

/**
 * Preview Access Approvers
 *
 * Who would approve these picks, for the company on the form (a read; POST for its body).
 *
 * 5 Oct: shown live under the role pickers at "Open and complete", from the
 * Master approval matrix, with whether each name is one ITSM employee.
 */
export const previewAccessApprovers = <ThrowOnError extends boolean = false>(
  options: Options<PreviewAccessApproversData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PreviewAccessApproversResponses,
    PreviewAccessApproversErrors,
    ThrowOnError
  >({
    url: "/access/cases/{case_id}/items/{n}/approvers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Decide Access Approval
 *
 * Approve or reject one approval need (5 Oct); a leaver's HR validation too (6 Oct).
 *
 * Only the approver the matrix names (resolved to one ITSM employee), or an
 * admin recording it on their behalf; once per need (409 after). The
 * decision is a journal note on the request, written first: if it cannot be
 * written, nothing is decided (502).
 */
export const decideAccessApproval = <ThrowOnError extends boolean = false>(
  options: Options<DecideAccessApprovalData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    DecideAccessApprovalResponses,
    DecideAccessApprovalErrors,
    ThrowOnError
  >({
    url: "/access/cases/{case_id}/items/{n}/approvals/{need_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List My Approvals
 *
 * "My approvals" (19 Oct): what waits for the signed-in approver, and their history.
 *
 * Only what they decide as the approver the matrix names, its backup or a
 * test approver on a test system; never what an admin could decide on
 * someone's behalf. Each with who it is for, what access, the reference
 * user and roles chosen, why, who asked, since when and when it is due.
 * Decide with `decideAccessApproval`, as on the case page.
 */
export const listMyApprovals = <ThrowOnError extends boolean = false>(
  options?: Options<ListMyApprovalsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListMyApprovalsResponses, unknown, ThrowOnError>({
    url: "/access/approvals",
    ...options,
  });

/**
 * Acknowledge Access Rejection
 *
 * The step's sender (or an admin) has seen an approver's rejection (19 Oct).
 *
 * Until then the rejected item is in their "Needs you" and the case stays
 * in progress (stage Rejected). 403 for anyone else; 409 when not rejected.
 */
export const acknowledgeAccessRejection = <ThrowOnError extends boolean = false>(
  options: Options<AcknowledgeAccessRejectionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AcknowledgeAccessRejectionResponses,
    AcknowledgeAccessRejectionErrors,
    ThrowOnError
  >({ url: "/access/cases/{case_id}/items/{n}/rejection-seen", ...options });

/**
 * Get Access Reference Profile
 *
 * The reference user's access on record, per system: the current picture only.
 *
 * WHY (5 Oct): HR copies a new hire's access "as the reference user", so
 * anyone who may use the wizard may ask — but this is a colleague's data,
 * so it answers the least that does the job: no tickets, no named-on, no
 * history. Logged at INFO (who asked about whom).
 */
export const getAccessReferenceProfile = <ThrowOnError extends boolean = false>(
  options: Options<GetAccessReferenceProfileData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAccessReferenceProfileResponses,
    GetAccessReferenceProfileErrors,
    ThrowOnError
  >({ url: "/access/reference-profile", ...options });

/**
 * Get Access Reference Access
 *
 * What the reference user has, per system, to keep, remove or add to (21 Oct).
 *
 * For the wizard (New user and Change) and Backoffice's "Roles to select":
 * anyone who may use the front door may ask, as for the reference profile,
 * and it answers access only (no tickets, no named-on). `compare_to`: mark
 * what that person (the one a Change is for) already has. `enabled` False
 * while `ACCESS_REFERENCE_IMPORT_ENABLED` is off. Logged at INFO.
 */
export const getAccessReferenceAccess = <ThrowOnError extends boolean = false>(
  options: Options<GetAccessReferenceAccessData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAccessReferenceAccessResponses,
    GetAccessReferenceAccessErrors,
    ThrowOnError
  >({ url: "/access/reference-access", ...options });

/**
 * Get Access Queues
 *
 * The work queues in IT Admin → Access (19 Oct, target New user flow).
 *
 * Global IT's new hires waiting for the account, laptop and core AD (with
 * the gate: in ITSM yes / check / no); Backoffice's "Roles to select" (New
 * users past the gate, with the reference user) and "Ready to assign"
 * (approved, rejected with the approvers' comments, or filed). For admins
 * and IT, as the rest of IT Admin → Access.
 */
export const getAccessQueues = <ThrowOnError extends boolean = false>(
  options?: Options<GetAccessQueuesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetAccessQueuesResponses, unknown, ThrowOnError>({
    url: "/access/queues",
    ...options,
  });

/**
 * Get Access Reference Roles
 *
 * The reference user's actual system roles, for Backoffice (19 Oct).
 *
 * "not_available" until the HelpDesk may read 365FO (the provider slot,
 * `ACCESS_REFERENCE_ROLES_PROVIDER`). Admins and IT only; logged at INFO.
 */
export const getAccessReferenceRoles = <ThrowOnError extends boolean = false>(
  options: Options<GetAccessReferenceRolesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAccessReferenceRolesResponses,
    GetAccessReferenceRolesErrors,
    ThrowOnError
  >({ url: "/access/reference-roles", ...options });

/**
 * List Access Completed
 *
 * Completed (archived) access cases, for auditors: each item's request and approvals.
 *
 * Admins and IT teams only (403 otherwise). Read back from Ivanti as the
 * tracker reads cases, over a wider, bounded window.
 */
export const listAccessCompleted = <ThrowOnError extends boolean = false>(
  options?: Options<ListAccessCompletedData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListAccessCompletedResponses,
    ListAccessCompletedErrors,
    ThrowOnError
  >({ url: "/access/completed", ...options });

/**
 * Export Access Completed
 *
 * The same list as an Excel workbook: one row per approval, and a "Read me" sheet.
 *
 * Every export is logged at INFO with who and which filter: an audit trail.
 */
export const exportAccessCompleted = <ThrowOnError extends boolean = false>(
  options?: Options<ExportAccessCompletedData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ExportAccessCompletedResponses,
    ExportAccessCompletedErrors,
    ThrowOnError
  >({ url: "/access/completed/export", ...options });

/**
 * Get My Training Roles
 *
 * The signed-in person's roles in the access process, detected, with completion state.
 *
 * Never fails on a slow or unreachable source: that role is listed in
 * `undetermined` and the page shows the role picker.
 */
export const getMyTrainingRoles = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyTrainingRolesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMyTrainingRolesResponses, unknown, ThrowOnError>({
    url: "/me/training-roles",
    ...options,
  });

/**
 * Complete Access Training
 *
 * Record a chapter as done: every question answered right. A retake updates it.
 *
 * 409 `TRAINING_VERSION_STALE` when the page showed another version (reload).
 */
export const completeAccessTraining = <ThrowOnError extends boolean = false>(
  options: Options<CompleteAccessTrainingData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CompleteAccessTrainingResponses,
    CompleteAccessTrainingErrors,
    ThrowOnError
  >({
    url: "/training/access/completions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Access Training Prompt
 *
 * Whether to show the requester prompt, or only the "How this works" link. No Ivanti call.
 */
export const getAccessTrainingPrompt = <ThrowOnError extends boolean = false>(
  options?: Options<GetAccessTrainingPromptData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetAccessTrainingPromptResponses, unknown, ThrowOnError>({
    url: "/training/access/prompt",
    ...options,
  });

/**
 * Dismiss Access Training Prompt
 *
 * "No thanks": never asked again at this training version.
 */
export const dismissAccessTrainingPrompt = <ThrowOnError extends boolean = false>(
  options?: Options<DismissAccessTrainingPromptData, ThrowOnError>,
) =>
  (options?.client ?? client).post<DismissAccessTrainingPromptResponses, unknown, ThrowOnError>({
    url: "/training/access/dismiss",
    ...options,
  });

/**
 * Get My Access Roster
 *
 * The roster entries that name the signed-in person, and their answers so far.
 */
export const getMyAccessRoster = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyAccessRosterData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMyAccessRosterResponses, unknown, ThrowOnError>({
    url: "/training/access/roster/mine",
    ...options,
  });

/**
 * Confirm Access Roster Entry
 *
 * "This is me", or "Not me – the right person is ___", for one entry that names me.
 *
 * 404 when the key is not one of the reader's entries.
 */
export const confirmAccessRosterEntry = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmAccessRosterEntryData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ConfirmAccessRosterEntryResponses,
    ConfirmAccessRosterEntryErrors,
    ThrowOnError
  >({
    url: "/training/access/confirmations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Access Training Progress
 *
 * Completion by role and by roster group (sites, companies, rules, teams), and corrections.
 */
export const getAccessTrainingProgress = <ThrowOnError extends boolean = false>(
  options?: Options<GetAccessTrainingProgressData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetAccessTrainingProgressResponses, unknown, ThrowOnError>({
    url: "/admin/access-training/progress",
    ...options,
  });

/**
 * Accept Access Training Correction
 *
 * Accept: kept on the roster entry and in the export.
 *
 * An approver's or an HR validator's (14 Oct) also returns `open_url`: the
 * rule's drawer in Approvers, prefilled with the right person, where the
 * change is made and audited. Others say where to make it (`apply_in`).
 */
export const acceptAccessTrainingCorrection = <ThrowOnError extends boolean = false>(
  options: Options<AcceptAccessTrainingCorrectionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AcceptAccessTrainingCorrectionResponses,
    AcceptAccessTrainingCorrectionErrors,
    ThrowOnError
  >({ url: "/admin/access-training/corrections/{correction_id}/accept", ...options });

/**
 * Dismiss Access Training Correction
 *
 * Dismiss: the roster stays as it is.
 */
export const dismissAccessTrainingCorrection = <ThrowOnError extends boolean = false>(
  options: Options<DismissAccessTrainingCorrectionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    DismissAccessTrainingCorrectionResponses,
    DismissAccessTrainingCorrectionErrors,
    ThrowOnError
  >({ url: "/admin/access-training/corrections/{correction_id}/dismiss", ...options });

/**
 * Export Access Training
 *
 * Progress, people, completions and roster answers as .xlsx (replaces the mailto loop).
 */
export const exportAccessTraining = <ThrowOnError extends boolean = false>(
  options?: Options<ExportAccessTrainingData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ExportAccessTrainingResponses, unknown, ThrowOnError>({
    url: "/admin/access-training/export",
    ...options,
  });

/**
 * Get It Admin Person
 *
 * One person's profile: card, access by system, open tickets, named on, not visible.
 *
 * 403 unless the caller is a HelpDesk admin or IT (`PersonProfiles.may_use_it_admin`).
 */
export const getItAdminPerson = <ThrowOnError extends boolean = false>(
  options: Options<GetItAdminPersonData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetItAdminPersonResponses, GetItAdminPersonErrors, ThrowOnError>({
    url: "/it-admin/people/{employee_id}",
    ...options,
  });

/**
 * Get It Admin Person Access
 *
 * A person's access at a glance, one card per system, every entry with its source (21 Oct).
 *
 * ITSM history, Resource owners and (once granted) the live 365FO roles;
 * systems no source answers yet say so. `enabled` False while
 * `ACCESS_REFERENCE_IMPORT_ENABLED` is off. 403 unless admin or IT; logged.
 */
export const getItAdminPersonAccess = <ThrowOnError extends boolean = false>(
  options: Options<GetItAdminPersonAccessData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetItAdminPersonAccessResponses,
    GetItAdminPersonAccessErrors,
    ThrowOnError
  >({ url: "/it-admin/people/{employee_id}/access", ...options });

/**
 * Get Assign Suggestion
 *
 * Where this ticket (incident or request, by number) should go, and why. Read-only.
 */
export const getAssignSuggestion = <ThrowOnError extends boolean = false>(
  options: Options<GetAssignSuggestionData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAssignSuggestionResponses,
    GetAssignSuggestionErrors,
    ThrowOnError
  >({ url: "/it-admin/assign/tickets/{ticket_number}", ...options });

/**
 * List Assign Teams
 *
 * The teams a ticket can be reassigned to (count-only teams left out).
 */
export const listAssignTeams = <ThrowOnError extends boolean = false>(
  options?: Options<ListAssignTeamsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListAssignTeamsResponses, unknown, ThrowOnError>({
    url: "/it-admin/assign/teams",
    ...options,
  });

/**
 * List Assign Team Members
 *
 * A team's current members (leavers and people without an email left out).
 */
export const listAssignTeamMembers = <ThrowOnError extends boolean = false>(
  options: Options<ListAssignTeamMembersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListAssignTeamMembersResponses,
    ListAssignTeamMembersErrors,
    ThrowOnError
  >({ url: "/it-admin/assign/teams/{team_id}/members", ...options });

/**
 * Reassign Ticket
 *
 * Move a ticket to a team (and owner), with a reason written as an internal note.
 */
export const reassignTicket = <ThrowOnError extends boolean = false>(
  options: Options<ReassignTicketData, ThrowOnError>,
) =>
  (options.client ?? client).post<ReassignTicketResponses, ReassignTicketErrors, ThrowOnError>({
    url: "/it-admin/assign/tickets/{ticket_id}/reassign",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search Tickets
 *
 * Incidents and service requests matching every given filter, newest first. Read only.
 *
 * At most `TICKET_SEARCH_MAX_RESULTS` rows (`capped` says more matched).
 * 403 unless the caller may use IT Admin; 504 when Ivanti is too slow.
 */
export const searchTickets = <ThrowOnError extends boolean = false>(
  options?: Options<SearchTicketsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<SearchTicketsResponses, SearchTicketsErrors, ThrowOnError>({
    url: "/it-admin/ticket-search",
    ...options,
  });

/**
 * Get Ticket Search Options
 *
 * The values each Ticket search pick list offers (Ivanti's lists and values in use).
 */
export const getTicketSearchOptions = <ThrowOnError extends boolean = false>(
  options?: Options<GetTicketSearchOptionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetTicketSearchOptionsResponses, unknown, ThrowOnError>({
    url: "/it-admin/ticket-search/options",
    ...options,
  });

/**
 * Suggest Assignment
 *
 * Who should this go to: by ticket number, or by pasted text (the ITSM summary).
 */
export const suggestAssignment = <ThrowOnError extends boolean = false>(
  options: Options<SuggestAssignmentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SuggestAssignmentResponses,
    SuggestAssignmentErrors,
    ThrowOnError
  >({
    url: "/it-admin/assign/suggest",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Routing Register
 *
 * The register (retired rules included), the dispatch group and the switches.
 */
export const getRoutingRegister = <ThrowOnError extends boolean = false>(
  options?: Options<GetRoutingRegisterData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetRoutingRegisterResponses, unknown, ThrowOnError>({
    url: "/it-admin/routing",
    ...options,
  });

/**
 * Add Routing Rule
 */
export const addRoutingRule = <ThrowOnError extends boolean = false>(
  options: Options<AddRoutingRuleData, ThrowOnError>,
) =>
  (options.client ?? client).post<AddRoutingRuleResponses, AddRoutingRuleErrors, ThrowOnError>({
    url: "/it-admin/routing/rules",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Routing Rule
 */
export const updateRoutingRule = <ThrowOnError extends boolean = false>(
  options: Options<UpdateRoutingRuleData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateRoutingRuleResponses, UpdateRoutingRuleErrors, ThrowOnError>(
    {
      url: "/it-admin/routing/rules/{rule_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

/**
 * Act On Routing Rule
 *
 * Accept or reject a proposed rule; retire, restore or confirm one.
 */
export const actOnRoutingRule = <ThrowOnError extends boolean = false>(
  options: Options<ActOnRoutingRuleData, ThrowOnError>,
) =>
  (options.client ?? client).post<ActOnRoutingRuleResponses, ActOnRoutingRuleErrors, ThrowOnError>({
    url: "/it-admin/routing/rules/{rule_id}/action",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Routing Audit
 */
export const listRoutingAudit = <ThrowOnError extends boolean = false>(
  options?: Options<ListRoutingAuditData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListRoutingAuditResponses, ListRoutingAuditErrors, ThrowOnError>({
    url: "/it-admin/routing/audit",
    ...options,
  });

/**
 * Decide Routing
 *
 * A dispatcher's answer to "needs a decision": logged, and saved as a rule.
 */
export const decideRouting = <ThrowOnError extends boolean = false>(
  options: Options<DecideRoutingData, ThrowOnError>,
) =>
  (options.client ?? client).post<DecideRoutingResponses, DecideRoutingErrors, ThrowOnError>({
    url: "/it-admin/routing/decisions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add Routing Dispatcher
 */
export const addRoutingDispatcher = <ThrowOnError extends boolean = false>(
  options: Options<AddRoutingDispatcherData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AddRoutingDispatcherResponses,
    AddRoutingDispatcherErrors,
    ThrowOnError
  >({
    url: "/it-admin/routing/dispatchers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove Dispatcher
 */
export const removeDispatcher = <ThrowOnError extends boolean = false>(
  options: Options<RemoveDispatcherData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    RemoveDispatcherResponses,
    RemoveDispatcherErrors,
    ThrowOnError
  >({ url: "/it-admin/routing/dispatchers/{dispatcher_id}", ...options });

/**
 * Set Dispatcher Away
 *
 * Mark a dispatcher away (until a day) or back: editors, or the dispatcher themselves.
 */
export const setDispatcherAway = <ThrowOnError extends boolean = false>(
  options: Options<SetDispatcherAwayData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    SetDispatcherAwayResponses,
    SetDispatcherAwayErrors,
    ThrowOnError
  >({
    url: "/it-admin/routing/dispatchers/{dispatcher_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Learn Routing Outcomes
 *
 * Read resolved tickets' final owners from Ivanti now (read only).
 */
export const learnRoutingOutcomes = <ThrowOnError extends boolean = false>(
  options?: Options<LearnRoutingOutcomesData, ThrowOnError>,
) =>
  (options?.client ?? client).post<LearnRoutingOutcomesResponses, unknown, ThrowOnError>({
    url: "/it-admin/routing/learn",
    ...options,
  });

/**
 * Run Auto Route
 *
 * Run auto-assign or the round robin on one existing ticket now (an editor's test).
 */
export const runAutoRoute = <ThrowOnError extends boolean = false>(
  options: Options<RunAutoRouteData, ThrowOnError>,
) =>
  (options.client ?? client).post<RunAutoRouteResponses, RunAutoRouteErrors, ThrowOnError>({
    url: "/it-admin/routing/auto-route",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Email Intake
 *
 * The processed mails (newest first), the counts of the last 7 days, the switches.
 */
export const listEmailIntake = <ThrowOnError extends boolean = false>(
  options?: Options<ListEmailIntakeData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListEmailIntakeResponses, ListEmailIntakeErrors, ThrowOnError>({
    url: "/it-admin/email-intake",
    ...options,
  });

/**
 * Get Email Intake Item
 *
 * One row with its audit trail (and, on UAT, the reply the test mailbox stored).
 */
export const getEmailIntakeItem = <ThrowOnError extends boolean = false>(
  options: Options<GetEmailIntakeItemData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetEmailIntakeItemResponses,
    GetEmailIntakeItemErrors,
    ThrowOnError
  >({ url: "/it-admin/email-intake/{row_id}", ...options });

/**
 * Act On Email Intake
 *
 * A person's decision from the review queue: create incident, send form link, ignore.
 */
export const actOnEmailIntake = <ThrowOnError extends boolean = false>(
  options: Options<ActOnEmailIntakeData, ThrowOnError>,
) =>
  (options.client ?? client).post<ActOnEmailIntakeResponses, ActOnEmailIntakeErrors, ThrowOnError>({
    url: "/it-admin/email-intake/{row_id}/action",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Run Email Intake Samples
 *
 * Put bundled sample mails in the test mailbox and run them (UAT only).
 */
export const runEmailIntakeSamples = <ThrowOnError extends boolean = false>(
  options: Options<RunEmailIntakeSamplesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RunEmailIntakeSamplesResponses,
    RunEmailIntakeSamplesErrors,
    ThrowOnError
  >({
    url: "/it-admin/email-intake/test/samples",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Upload Email Intake Mail
 *
 * Upload one `.eml` into the test mailbox and run it (UAT only).
 */
export const uploadEmailIntakeMail = <ThrowOnError extends boolean = false>(
  options: Options<UploadEmailIntakeMailData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UploadEmailIntakeMailResponses,
    UploadEmailIntakeMailErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/it-admin/email-intake/test/upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Upload Report
 *
 * Store a new copy of a self-contained HTML report; keeps the newest 30.
 *
 * For the daily script (`Authorization: Bearer <REPORT_UPLOAD_TOKEN>`) and
 * for viewers signed in.
 */
export const uploadReport = <ThrowOnError extends boolean = false>(
  options: Options<UploadReportData, ThrowOnError>,
) =>
  (options.client ?? client).post<UploadReportResponses, UploadReportErrors, ThrowOnError>({
    url: "/admin/reports/{name}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Report Snapshots
 *
 * The stored copies of a report, newest first (for the date picker).
 */
export const listReportSnapshots = <ThrowOnError extends boolean = false>(
  options: Options<ListReportSnapshotsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListReportSnapshotsResponses,
    ListReportSnapshotsErrors,
    ThrowOnError
  >({ url: "/admin/reports/{name}/snapshots", ...options });

/**
 * Get Latest Report
 *
 * The newest copy of a report, with its HTML. 404 while none was uploaded.
 */
export const getLatestReport = <ThrowOnError extends boolean = false>(
  options: Options<GetLatestReportData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetLatestReportResponses, GetLatestReportErrors, ThrowOnError>({
    url: "/admin/reports/{name}/latest",
    ...options,
  });

/**
 * Get Report Snapshot
 *
 * One stored copy of a report, with its HTML.
 */
export const getReportSnapshot = <ThrowOnError extends boolean = false>(
  options: Options<GetReportSnapshotData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetReportSnapshotResponses, GetReportSnapshotErrors, ThrowOnError>(
    { url: "/admin/reports/{name}/snapshots/{snapshot_id}", ...options },
  );

/**
 * Add Report Note
 *
 * Add a note for the IT HelpDesk (16 Oct): a data point, an update, a suggestion.
 *
 * Stored in the Feedback inbox ("Leadership report" view) with the page's
 * dates and filters and, when written under an "Ask about this report"
 * answer, that question and answer. No email; a Teams card only with
 * `LEADERSHIP_REPORT_NOTE_TEAMS` on.
 */
export const addReportNote = <ThrowOnError extends boolean = false>(
  options: Options<AddReportNoteData, ThrowOnError>,
) =>
  (options.client ?? client).post<AddReportNoteResponses, AddReportNoteErrors, ThrowOnError>({
    url: "/admin/reports/{name}/notes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Leadership Feedback
 *
 * The Feedback inbox's "Leadership report" view: every report comment, newest first.
 *
 * `status` keeps the open or the resolved questions (9 Oct); `counts` is
 * open vs resolved over all of them.
 */
export const adminListLeadershipFeedback = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListLeadershipFeedbackData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminListLeadershipFeedbackResponses,
    AdminListLeadershipFeedbackErrors,
    ThrowOnError
  >({ url: "/admin/feedback/leadership", ...options });

/**
 * Get Report Refresh Status
 *
 * The refresh: when the data was pulled, the next slot, a failed last run.
 *
 * `can_update_now` is true for Rusty alone (12 Oct): the page shows
 * "Update now" to nobody else.
 */
export const getReportRefreshStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetReportRefreshStatusData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetReportRefreshStatusResponses,
    GetReportRefreshStatusErrors,
    ThrowOnError
  >({ url: "/admin/reports/{name}/status", ...options });

/**
 * Update Report Now
 *
 * "Update now" (12 Oct): pull the data again, in the background.
 *
 * Rusty only (either domain), every other viewer and every admin gets 403;
 * at most once per 15 minutes (429 with Retry-After). The same job as the
 * scheduled refresh, under the same lock; the page polls the status.
 */
export const updateReportNow = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReportNowData, ThrowOnError>,
) =>
  (options.client ?? client).post<UpdateReportNowResponses, UpdateReportNowErrors, ThrowOnError>({
    url: "/admin/reports/{name}/refresh",
    ...options,
  });

/**
 * Get Report Insights
 *
 * Every number of the interactive page for a range and filters (from the newest data).
 *
 * Tiles carry the change against the previous equal-length period (or, for
 * open now and past target, an older snapshot). 404 until the first refresh
 * that stores data.
 */
export const getReportInsights = <ThrowOnError extends boolean = false>(
  options: Options<GetReportInsightsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetReportInsightsResponses, GetReportInsightsErrors, ThrowOnError>(
    { url: "/admin/reports/{name}/insights", ...options },
  );

/**
 * List Report Insight Tickets
 *
 * The tickets behind one number of the page (the drill-in drawer).
 */
export const listReportInsightTickets = <ThrowOnError extends boolean = false>(
  options: Options<ListReportInsightTicketsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListReportInsightTicketsResponses,
    ListReportInsightTicketsErrors,
    ThrowOnError
  >({ url: "/admin/reports/{name}/insights/tickets", ...options });

/**
 * Export Report Insights
 *
 * Download Excel: summary, daily by channel, teams, SLA and the ticket list, as on screen.
 *
 * `section` (28 Oct): only that section's sheets, for the section's own "Export".
 */
export const exportReportInsights = <ThrowOnError extends boolean = false>(
  options: Options<ExportReportInsightsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ExportReportInsightsResponses,
    ExportReportInsightsErrors,
    ThrowOnError
  >({ url: "/admin/reports/{name}/insights/export", ...options });

/**
 * Ask Report
 *
 * Answer a plain-language question from the report's stored data (read-only).
 *
 * Same viewers as the report (403 for everyone else, other admins and "View
 * as" included). The answer reads only the newest refresh's data for the
 * page's range and filters, through read-only tools that compute every
 * number in code; nothing calls Ivanti. Each question and answer is stored
 * in the Feedback inbox (`rating = ASK`). Limits: `LEADERSHIP_ASK_PER_HOUR`
 * per person, `LEADERSHIP_ASK_MAX_TOKENS` per question and
 * `LEADERSHIP_ASK_TOKENS_PER_DAY` per person (429). A failed model call is a
 * 503, logged as feedback and sent to Teams like every server error.
 */
export const askReport = <ThrowOnError extends boolean = false>(
  options: Options<AskReportData, ThrowOnError>,
) =>
  (options.client ?? client).post<AskReportResponses, AskReportErrors, ThrowOnError>({
    url: "/admin/reports/{name}/ask",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Approvers Overview
 *
 * The tabs (areas from the role source), the 365FO columns, and where it comes from.
 */
export const getApproversOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetApproversOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetApproversOverviewResponses, unknown, ThrowOnError>({
    url: "/admin/approvers",
    ...options,
  });

/**
 * List Approver Rules
 *
 * Every rule (of a system), filtered by area, entity / region scope, or approver.
 *
 * `approver` matches the approver's, the delegate's or a choice's name or
 * email, ignoring case.
 */
export const listApproverRules = <ThrowOnError extends boolean = false>(
  options?: Options<ListApproverRulesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListApproverRulesResponses,
    ListApproverRulesErrors,
    ThrowOnError
  >({ url: "/admin/approvers/rules", ...options });

/**
 * Create Approver Rule
 *
 * Add a rule naming an approver picked from the directory.
 */
export const createApproverRule = <ThrowOnError extends boolean = false>(
  options: Options<CreateApproverRuleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateApproverRuleResponses,
    CreateApproverRuleErrors,
    ThrowOnError
  >({
    url: "/admin/approvers/rules",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Resource Owner
 *
 * Name the owner (and a backup) of a SharePoint site or shared folder (14 Oct).
 *
 * Access - Folder or SharePoint item requests naming that resource (or
 * anything under it) are approved by the owner, or the backup.
 */
export const createResourceOwner = <ThrowOnError extends boolean = false>(
  options: Options<CreateResourceOwnerData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateResourceOwnerResponses,
    CreateResourceOwnerErrors,
    ThrowOnError
  >({
    url: "/admin/approvers/resources",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Resource Owner
 *
 * A new owner and / or backup (none clears the backup) for a resource.
 */
export const updateResourceOwner = <ThrowOnError extends boolean = false>(
  options: Options<UpdateResourceOwnerData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateResourceOwnerResponses,
    UpdateResourceOwnerErrors,
    ThrowOnError
  >({
    url: "/admin/approvers/resources/{rule_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set Approver Backup
 *
 * A rule's backup (14 Oct: HR validators, resource owners); none clears it.
 */
export const setApproverBackup = <ThrowOnError extends boolean = false>(
  options: Options<SetApproverBackupData, ThrowOnError>,
) =>
  (options.client ?? client).put<SetApproverBackupResponses, SetApproverBackupErrors, ThrowOnError>(
    {
      url: "/admin/approvers/rules/{rule_id}/backup",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

/**
 * Set Approver Confirmed
 *
 * Mark a site owner confirmed, or a placeholder to confirm again (15 Oct); audited.
 */
export const setApproverConfirmed = <ThrowOnError extends boolean = false>(
  options: Options<SetApproverConfirmedData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    SetApproverConfirmedResponses,
    SetApproverConfirmedErrors,
    ThrowOnError
  >({
    url: "/admin/approvers/rules/{rule_id}/confirmed",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add Hr Group Member
 *
 * Add someone to the HR group (14 Oct): their leaver requests count as valid as raised.
 */
export const addHrGroupMember = <ThrowOnError extends boolean = false>(
  options: Options<AddHrGroupMemberData, ThrowOnError>,
) =>
  (options.client ?? client).post<AddHrGroupMemberResponses, AddHrGroupMemberErrors, ThrowOnError>({
    url: "/admin/approvers/hr-group",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Retired Approvers
 *
 * Every retired rule, area of an entity, or whole entity (14 Oct), newest first.
 */
export const listRetiredApprovers = <ThrowOnError extends boolean = false>(
  options?: Options<ListRetiredApproversData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListRetiredApproversResponses, unknown, ThrowOnError>({
    url: "/admin/approvers/retired",
    ...options,
  });

/**
 * Retire Approvers
 *
 * Retire one rule, one area of an entity, or a whole entity (area "*") (14 Oct).
 *
 * Nothing is deleted: retired rules no longer route approvals and are not
 * counted as problems; `POST /admin/approvers/unretire` restores them.
 */
export const retireApprovers = <ThrowOnError extends boolean = false>(
  options: Options<RetireApproversData, ThrowOnError>,
) =>
  (options.client ?? client).post<RetireApproversResponses, RetireApproversErrors, ThrowOnError>({
    url: "/admin/approvers/retire",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Unretire Approvers
 *
 * Restore what was retired (14 Oct); audited like the retirement.
 */
export const unretireApprovers = <ThrowOnError extends boolean = false>(
  options: Options<UnretireApproversData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UnretireApproversResponses,
    UnretireApproversErrors,
    ThrowOnError
  >({
    url: "/admin/approvers/unretire",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Approver Rule
 *
 * Remove a rule; picks it covered then show "no rule in the matrix".
 */
export const deleteApproverRule = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApproverRuleData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteApproverRuleResponses,
    DeleteApproverRuleErrors,
    ThrowOnError
  >({ url: "/admin/approvers/rules/{rule_id}", ...options });

/**
 * Update Approver Rule
 *
 * Name a new approver (picked from the directory) and optionally change the note.
 */
export const updateApproverRule = <ThrowOnError extends boolean = false>(
  options: Options<UpdateApproverRuleData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateApproverRuleResponses,
    UpdateApproverRuleErrors,
    ThrowOnError
  >({
    url: "/admin/approvers/rules/{rule_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * End Approver Covering
 *
 * End "covering for": approvals go to the rule's own approver again.
 */
export const endApproverCovering = <ThrowOnError extends boolean = false>(
  options: Options<EndApproverCoveringData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    EndApproverCoveringResponses,
    EndApproverCoveringErrors,
    ThrowOnError
  >({ url: "/admin/approvers/rules/{rule_id}/covering", ...options });

/**
 * Set Approver Covering
 *
 * Covering for: approvals from `start` to `end` (inclusive) go to this person.
 */
export const setApproverCovering = <ThrowOnError extends boolean = false>(
  options: Options<SetApproverCoveringData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    SetApproverCoveringResponses,
    SetApproverCoveringErrors,
    ThrowOnError
  >({
    url: "/admin/approvers/rules/{rule_id}/covering",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Bulk Change Approvers
 *
 * Name one person on many rules: preview first, then apply (one audit row per rule).
 *
 * "Replace everywhere" (an approver leaves), a global rule edited in one go,
 * and "apply this change to all of them too" all come here. With `covering`
 * the person is the delegate for those days instead of the new approver.
 */
export const bulkChangeApprovers = <ThrowOnError extends boolean = false>(
  options: Options<BulkChangeApproversData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BulkChangeApproversResponses,
    BulkChangeApproversErrors,
    ThrowOnError
  >({
    url: "/admin/approvers/bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Approver System
 *
 * Add an "Other" system (e.g. ExFlow); its rules are then added like any other.
 */
export const createApproverSystem = <ThrowOnError extends boolean = false>(
  options: Options<CreateApproverSystemData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateApproverSystemResponses,
    CreateApproverSystemErrors,
    ThrowOnError
  >({
    url: "/admin/approvers/systems",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Approver System
 *
 * Remove an "Other" system and all its rules (audited). Built-in systems cannot go.
 */
export const deleteApproverSystem = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApproverSystemData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteApproverSystemResponses,
    DeleteApproverSystemErrors,
    ThrowOnError
  >({ url: "/admin/approvers/systems/{key}", ...options });

/**
 * List Approver History
 *
 * Every change, newest first; one rule's with `system` and `rule_key` ("finance|USL").
 */
export const listApproverHistory = <ThrowOnError extends boolean = false>(
  options?: Options<ListApproverHistoryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListApproverHistoryResponses,
    ListApproverHistoryErrors,
    ThrowOnError
  >({ url: "/admin/approvers/history", ...options });

/**
 * Get Approver Problems
 *
 * Approvers not found / left / ambiguous in ITSM, picks with no rule, ended delegates.
 */
export const getApproverProblems = <ThrowOnError extends boolean = false>(
  options?: Options<GetApproverProblemsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetApproverProblemsResponses,
    GetApproverProblemsErrors,
    ThrowOnError
  >({ url: "/admin/approvers/problems", ...options });

/**
 * Export Approver Problems
 *
 * "Export issues" (13 Oct): the people to sort out and the picks with no rule, as .xlsx.
 */
export const exportApproverProblems = <ThrowOnError extends boolean = false>(
  options?: Options<ExportApproverProblemsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ExportApproverProblemsResponses, unknown, ThrowOnError>({
    url: "/admin/approvers/problems/export",
    ...options,
  });

/**
 * Accept Approver Matches
 *
 * Accept suggested matches (13 Oct): pin each name to an employee on its rules.
 *
 * One item is the one-click "Accept" (or a pick among the candidates);
 * several are "Accept all suggested", previewed first (`apply` false). Every
 * rule that changes gets its own audit row (`accept_match`).
 */
export const acceptApproverMatches = <ThrowOnError extends boolean = false>(
  options: Options<AcceptApproverMatchesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AcceptApproverMatchesResponses,
    AcceptApproverMatchesErrors,
    ThrowOnError
  >({
    url: "/admin/approvers/accept",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Unmark Approver Not Applicable
 *
 * Undo "not applicable": the pick counts as a gap again (audited).
 */
export const unmarkApproverNotApplicable = <ThrowOnError extends boolean = false>(
  options: Options<UnmarkApproverNotApplicableData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    UnmarkApproverNotApplicableResponses,
    UnmarkApproverNotApplicableErrors,
    ThrowOnError
  >({ url: "/admin/approvers/not-applicable", ...options });

/**
 * Mark Approver Not Applicable
 *
 * A pick with no rule that never needs one (13 Oct); audited, undone by DELETE.
 */
export const markApproverNotApplicable = <ThrowOnError extends boolean = false>(
  options: Options<MarkApproverNotApplicableData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MarkApproverNotApplicableResponses,
    MarkApproverNotApplicableErrors,
    ThrowOnError
  >({
    url: "/admin/approvers/not-applicable",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Export Approvers
 *
 * The matrix as the master's sheets (Approval rules, Entities) plus a Read me.
 */
export const exportApprovers = <ThrowOnError extends boolean = false>(
  options?: Options<ExportApproversData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ExportApproversResponses, unknown, ThrowOnError>({
    url: "/admin/approvers/export",
    ...options,
  });

/**
 * Import Approvers
 *
 * Compare a workbook with the matrix; with `apply`, write the differences (audited).
 */
export const importApprovers = <ThrowOnError extends boolean = false>(
  options: Options<ImportApproversData, ThrowOnError>,
) =>
  (options.client ?? client).post<ImportApproversResponses, ImportApproversErrors, ThrowOnError>({
    url: "/admin/approvers/import",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Knowledge Overview
 *
 * Counts by status and area, review due, recent changes.
 */
export const getKnowledgeOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetKnowledgeOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetKnowledgeOverviewResponses, unknown, ThrowOnError>({
    url: "/knowledge/overview",
    ...options,
  });

/**
 * List Knowledge Articles
 *
 * Every article, filtered (search, status, tag, area incl. sub-areas, owner, review due…).
 */
export const listKnowledgeArticles = <ThrowOnError extends boolean = false>(
  options?: Options<ListKnowledgeArticlesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListKnowledgeArticlesResponses,
    ListKnowledgeArticlesErrors,
    ThrowOnError
  >({ url: "/knowledge/articles", ...options });

/**
 * Create Knowledge Article
 *
 * A new draft.
 */
export const createKnowledgeArticle = <ThrowOnError extends boolean = false>(
  options: Options<CreateKnowledgeArticleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateKnowledgeArticleResponses,
    CreateKnowledgeArticleErrors,
    ThrowOnError
  >({
    url: "/knowledge/articles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Knowledge Article
 *
 * One article in full (any status), for IT.
 */
export const getKnowledgeArticle = <ThrowOnError extends boolean = false>(
  options: Options<GetKnowledgeArticleData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetKnowledgeArticleResponses,
    GetKnowledgeArticleErrors,
    ThrowOnError
  >({ url: "/knowledge/articles/{article_id}", ...options });

/**
 * Update Knowledge Article
 *
 * Save an edit as the next version (409 if someone saved in between); re-index if published.
 */
export const updateKnowledgeArticle = <ThrowOnError extends boolean = false>(
  options: Options<UpdateKnowledgeArticleData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateKnowledgeArticleResponses,
    UpdateKnowledgeArticleErrors,
    ThrowOnError
  >({
    url: "/knowledge/articles/{article_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Knowledge Versions
 *
 * The article's history, newest first: full snapshots and review comments.
 */
export const listKnowledgeVersions = <ThrowOnError extends boolean = false>(
  options: Options<ListKnowledgeVersionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListKnowledgeVersionsResponses,
    ListKnowledgeVersionsErrors,
    ThrowOnError
  >({ url: "/knowledge/articles/{article_id}/versions", ...options });

/**
 * Comment Knowledge Article
 *
 * A review comment from any IT reader: history only, it blocks nothing.
 */
export const commentKnowledgeArticle = <ThrowOnError extends boolean = false>(
  options: Options<CommentKnowledgeArticleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CommentKnowledgeArticleResponses,
    CommentKnowledgeArticleErrors,
    ThrowOnError
  >({
    url: "/knowledge/articles/{article_id}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Read Knowledge Article
 *
 * The read-only page a chat citation opens: published only; "IT only" only for IT.
 */
export const readKnowledgeArticle = <ThrowOnError extends boolean = false>(
  options: Options<ReadKnowledgeArticleData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ReadKnowledgeArticleResponses,
    ReadKnowledgeArticleErrors,
    ThrowOnError
  >({ url: "/knowledge/read/{article_id}", ...options });

/**
 * Set Knowledge Article Status
 *
 * Publish (and index), unpublish (back to draft) or retire (out of the index, kept).
 */
export const setKnowledgeArticleStatus = <ThrowOnError extends boolean = false>(
  options: Options<SetKnowledgeArticleStatusData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SetKnowledgeArticleStatusResponses,
    SetKnowledgeArticleStatusErrors,
    ThrowOnError
  >({
    url: "/knowledge/articles/{article_id}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reindex Knowledge Article
 *
 * Retry indexing one published article.
 */
export const reindexKnowledgeArticle = <ThrowOnError extends boolean = false>(
  options: Options<ReindexKnowledgeArticleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ReindexKnowledgeArticleResponses,
    ReindexKnowledgeArticleErrors,
    ThrowOnError
  >({ url: "/knowledge/articles/{article_id}/reindex", ...options });

/**
 * Reindex Knowledge
 *
 * Retry indexing every published article the chat cannot find yet.
 */
export const reindexKnowledge = <ThrowOnError extends boolean = false>(
  options?: Options<ReindexKnowledgeData, ThrowOnError>,
) =>
  (options?.client ?? client).post<ReindexKnowledgeResponses, unknown, ThrowOnError>({
    url: "/knowledge/reindex",
    ...options,
  });

/**
 * Preview Knowledge Import
 *
 * Read the dropped files (one article per file / sheet row): nothing is saved.
 */
export const previewKnowledgeImport = <ThrowOnError extends boolean = false>(
  options: Options<PreviewKnowledgeImportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PreviewKnowledgeImportResponses,
    PreviewKnowledgeImportErrors,
    ThrowOnError
  >({
    url: "/knowledge/import/preview",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Knowledge Imports
 *
 * The newest bulk adds.
 */
export const listKnowledgeImports = <ThrowOnError extends boolean = false>(
  options?: Options<ListKnowledgeImportsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListKnowledgeImportsResponses, unknown, ThrowOnError>({
    url: "/knowledge/import",
    ...options,
  });

/**
 * Commit Knowledge Import
 *
 * Save a bulk add: as drafts, published, or as marked; large ones index in the background.
 */
export const commitKnowledgeImport = <ThrowOnError extends boolean = false>(
  options: Options<CommitKnowledgeImportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CommitKnowledgeImportResponses,
    CommitKnowledgeImportErrors,
    ThrowOnError
  >({
    url: "/knowledge/import",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Knowledge Import
 *
 * One bulk add and its indexing progress.
 */
export const getKnowledgeImport = <ThrowOnError extends boolean = false>(
  options: Options<GetKnowledgeImportData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetKnowledgeImportResponses,
    GetKnowledgeImportErrors,
    ThrowOnError
  >({ url: "/knowledge/import/{batch_id}", ...options });

/**
 * Export Knowledge
 *
 * Every article: a .zip of Markdown with front matter (bulk add reads it back) or a sheet.
 */
export const exportKnowledge = <ThrowOnError extends boolean = false>(
  options?: Options<ExportKnowledgeData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ExportKnowledgeResponses, ExportKnowledgeErrors, ThrowOnError>({
    url: "/knowledge/export",
    ...options,
  });

/**
 * List Knowledge Areas
 *
 * The area tree (retired areas included, marked).
 */
export const listKnowledgeAreas = <ThrowOnError extends boolean = false>(
  options?: Options<ListKnowledgeAreasData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListKnowledgeAreasResponses, unknown, ThrowOnError>({
    url: "/knowledge/areas",
    ...options,
  });

/**
 * Create Knowledge Area
 *
 * Add an area (its id is a stable slug of its name).
 */
export const createKnowledgeArea = <ThrowOnError extends boolean = false>(
  options: Options<CreateKnowledgeAreaData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateKnowledgeAreaResponses,
    CreateKnowledgeAreaErrors,
    ThrowOnError
  >({
    url: "/knowledge/areas",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Knowledge Area
 *
 * Rename, describe, re-key, move, retire or restore an area; its id never changes.
 */
export const updateKnowledgeArea = <ThrowOnError extends boolean = false>(
  options: Options<UpdateKnowledgeAreaData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateKnowledgeAreaResponses,
    UpdateKnowledgeAreaErrors,
    ThrowOnError
  >({
    url: "/knowledge/areas/{area_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Stop View As
 *
 * Back to the admin's own view.
 */
export const stopViewAs = <ThrowOnError extends boolean = false>(
  options?: Options<StopViewAsData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<StopViewAsResponses, unknown, ThrowOnError>({
    url: "/admin/view-as",
    ...options,
  });

/**
 * Start View As
 *
 * View the app as this person, read-only, for up to an hour (admins on VIEW_AS_EMAILS).
 *
 * Starting again while viewing switches to the new person.
 */
export const startViewAs = <ThrowOnError extends boolean = false>(
  options: Options<StartViewAsData, ThrowOnError>,
) =>
  (options.client ?? client).post<StartViewAsResponses, StartViewAsErrors, ThrowOnError>({
    url: "/admin/view-as",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Demo Personas
 *
 * Who plays which role in the demo (UAT test identities), as ITSM holds them.
 */
export const listDemoPersonas = <ThrowOnError extends boolean = false>(
  options?: Options<ListDemoPersonasData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListDemoPersonasResponses, unknown, ThrowOnError>({
    url: "/admin/demo-personas",
    ...options,
  });

/**
 * Start Demo Persona
 *
 * A persona for one browser tab (8 hours at most; it also ends with the session).
 *
 * A "[UAT TEST]" person may act (approve, reject, pick roles, comment), signed
 * "(demo, by …)"; anyone else is read-only, exactly as View as.
 */
export const startDemoPersona = <ThrowOnError extends boolean = false>(
  options: Options<StartDemoPersonaData, ThrowOnError>,
) =>
  (options.client ?? client).post<StartDemoPersonaResponses, StartDemoPersonaErrors, ThrowOnError>({
    url: "/admin/demo-personas/token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Prepare Demo Personas
 *
 * Put the demo cast in place on UAT (idempotent): teams, coverings.
 */
export const prepareDemoPersonas = <ThrowOnError extends boolean = false>(
  options?: Options<PrepareDemoPersonasData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PrepareDemoPersonasResponses, unknown, ThrowOnError>({
    url: "/admin/demo-personas/prepare",
    ...options,
  });

/**
 * Reset Demo Personas
 *
 * Cancel the demo case ("[UAT TEST]" only); with `undo_setup`, undo prepare too.
 */
export const resetDemoPersonas = <ThrowOnError extends boolean = false>(
  options: Options<ResetDemoPersonasData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ResetDemoPersonasResponses,
    ResetDemoPersonasErrors,
    ThrowOnError
  >({
    url: "/admin/demo-personas/reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Demo Case
 *
 * Prepare, then a fresh demo New user past the gate, waiting in Backoffice.
 *
 * Filed as the "[UAT TEST] Demo HR" persona for "[UAT TEST] Demo New Hire"
 * (USLAG, 365FO + Bluestar + CRM). An open demo case already: nothing is
 * filed, and its number comes back (`created` false).
 */
export const createDemoCase = <ThrowOnError extends boolean = false>(
  options?: Options<CreateDemoCaseData, ThrowOnError>,
) =>
  (options?.client ?? client).post<CreateDemoCaseResponses, unknown, ThrowOnError>({
    url: "/admin/demo-personas/demo-case",
    ...options,
  });

/**
 * Hr Portal File New User
 *
 * File an "Access - New user" exactly as the HR Portal does (UAT only).
 */
export const hrPortalFileNewUser = <ThrowOnError extends boolean = false>(
  options: Options<HrPortalFileNewUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    HrPortalFileNewUserResponses,
    HrPortalFileNewUserErrors,
    ThrowOnError
  >({
    url: "/admin/demo-personas/hr-portal/new-user",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Hr Portal File Leaver
 *
 * File an "Access - Leaver" exactly as the HR Portal does (UAT only).
 */
export const hrPortalFileLeaver = <ThrowOnError extends boolean = false>(
  options: Options<HrPortalFileLeaverData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    HrPortalFileLeaverResponses,
    HrPortalFileLeaverErrors,
    ThrowOnError
  >({
    url: "/admin/demo-personas/hr-portal/leaver",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Hr Portal Pick Up
 *
 * Adopt that request now, rather than waiting for the watcher (up to 15 minutes).
 */
export const hrPortalPickUp = <ThrowOnError extends boolean = false>(
  options: Options<HrPortalPickUpData, ThrowOnError>,
) =>
  (options.client ?? client).post<HrPortalPickUpResponses, HrPortalPickUpErrors, ThrowOnError>({
    url: "/admin/demo-personas/hr-portal/pick-up",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Health
 *
 * Liveness. Is this process running?
 *
 * Deliberately checks nothing: an Ivanti outage is not a reason to restart
 * the container. Readiness is `/health/ready`.
 */
export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
    url: "/health",
    ...options,
  });

/**
 * Auth Logout
 *
 * Sign out — clear the session cookie and drop any delegated Graph token.
 *
 * The session is read best-effort rather than through `SessionDep`: signing
 * out with an already-expired cookie has to keep working, and a 401 here
 * would leave the browser holding it. Dropping the Graph token is local only
 * — the consent still stands at Entra — but it stops a live delegated token,
 * and the refresh token behind it when `offline_access` was approved, from
 * outliving the session that obtained it and being inherited by the next
 * one signed in under the same email.
 *
 * It also leaves `PICK_ACCOUNT_COOKIE`, so the next Microsoft sign-in on this
 * browser shows the account picker (shared PCs, 2 Oct).
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
) =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    url: "/auth/logout",
    ...options,
  });

/**
 * Auth Me
 *
 * Return the current session's identity.
 *
 * `can_view_teams` shows the Teams area and `can_manage_teams` says the
 * person may change at least one team (8 Oct: all of IT sees every team,
 * read-only; admins and each team's own manager edit). Both are false while
 * `TEAMS_AREA_ENABLED` is off, with no Ivanti call; otherwise bounded in
 * time (2.5 s), any failure "no" and remembered (60 s), never a 500.
 * `has_starter_cases` shows the "New starters" entry: cached per person,
 * bounded in time, and "no" whenever it cannot be decided (2 Oct).
 * `access_front_door` shows "Change access" (5 Oct; 28 Oct: Change only).
 * `access_new_forms` (28 Oct) hides the old-forms screens on the new forms.
 * `it_admin` shows the IT Admin area (5 Oct): switched on, and an admin or
 * an IT team member — bounded in time, "no" when it cannot be decided, and
 * no Ivanti call at all while `IT_ADMIN_ENABLED` is off.
 * `kiosk` is set on a shared device, so the frontend asks who is using it
 * before anything else (1 Oct); null for everyone else. A shared device
 * gets none of the staff areas above, and costs no Ivanti call for them.
 * `access_audit` shows the Access page's "Completed" tab (6 Oct): the front
 * door on, and the same rule as IT Admin.
 * `view_as` (6 Oct) is set while an admin views the app as this person, and
 * `can_view_as` offers "View as…" to an admin on VIEW_AS_EMAILS (LIVE: Rusty).
 * `can_demo_as` (19 Oct) offers "Demo as…", the per-tab personas: the same
 * admins, never in production, and not while "View as" is on (a persona's
 * own tab keeps it, to switch or go back).
 * `knowledge_editor` (9 Oct) shows Knowledge → Bulk add and Areas: on
 * `KNOWLEDGE_EDITORS`; every IT user reads Overview and Articles
 * (`knowledge_area`, 13 Oct: `it_admin` with `KNOWLEDGE_AREA_ENABLED` on).
 * `leadership_report` shows the IT Admin "Leadership report" (8 Oct): the
 * person is a member of the Ivanti team `LEADERSHIP_REPORT_TEAM`, on
 * `LEADERSHIP_REPORT_VIEWERS`, or Rusty; the team check is cached per person
 * and fails closed. Every flag here is the viewed person's while "View as" is
 * on (22 Oct: the Leadership report too, never the admin's own).
 * `approvers` (12 Oct) shows IT Admin → Management → Approvers: an admin, or
 * a member of an `APPROVERS_EDITOR_TEAMS` Ivanti team (cached per person,
 * fails closed).
 * `itsm_url` (23 Oct) is the Ivanti console origin for "Copy link → ITSM
 * link": IT and admins only (the IT Admin rule), null for everyone else.
 */
export const getMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({
    url: "/auth/me",
    ...options,
  });
